import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const Svg = styled.svg`
  fill: ${({ color }) => color && color} !important;

  mask-size: cover;

  mask {
    mask-size: cover;
    width: 100%;
    height: 100%;
    -webkit-mask-size: cover;
  }

  path {
    fill: ${({ color }) => color && color} !important;
  }
`;
const Span = styled.span`
  ${({ isAdminModule }) =>
    isAdminModule &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

const SvgIcon = function ({ children, title, noFlex, ...props }) {
  const {
    location: { pathname },
  } = useHistory();
  const isAdminModule = pathname.includes('admin');
  return (
    <Span title={title} isAdminModule={isAdminModule && !noFlex}>
      <Svg {...props}>{children}</Svg>
    </Span>
  );
};

export const iconTypes = {
  ADD_CIRCLE: 'add-circle',
  ADD_NEW: 'add-project',
  ADD_FOLDER: 'add-folder',
  ADM: 'adm',
  ALERT: 'alert-circled',
  ARCHIVE: 'archive',
  ARROW_DOWN: 'arrow-down',
  ARROW_DOWN_ALT: 'arrow-down-alt',
  ARROW_UP_ALT: 'arrow-up-alt',
  ARROW_DOUBLE_LEFT: 'arrow-double-left',
  ARROW_DOUBLE_RIGHT: 'arrow-double-right',
  ARROW_DOUBLE_DOWN: 'arrow-double-down',
  ARROW_DOUBLE_UP: 'arrow-double-up',
  ARROW_SIMPLE_UP: 'arrow-simple-up',
  ARROW_SIMPLE_DOWN: 'arrow-simple-down',
  ASTERISK: 'asterisk',
  ASK: 'ask',
  BACK: 'back',
  BELL_ON: 'bell-on',
  BELL_OFF: 'bell-off',
  BOOKMARK: 'bookmark',
  BOMB: 'bomb',
  BULLHORN: 'bullhorn',
  CALENDAR: 'calendar',
  CALENDAR_DOWN: 'calendar-down',
  CALENDAR_UP: 'calendar-up',
  CAMERA: 'camera',
  CHAT: 'chat',
  CHART_PIE: 'chart-pie',
  GANTT_CHART: 'gantt-chart',
  CHECK: 'check',
  CHECK_SQUARE: 'check-square',
  CHECK_SQUARE_EMPTY: 'check-square-empty',
  CLOCK: 'clock',
  CLOUD: 'cloud',
  CLOUD_DOWN: 'cloud-down',
  CLOUD_UP: 'cloud-up',
  COPY: 'copy',
  CANCEL: 'cancel',
  CUBE: 'cube',
  CUBE_WIRE: 'cube-wire',
  CUBES: 'cubes',
  DOCUMENT: 'document',
  DRAW_ARROW: 'draw-arrow',
  DRAW_CIRCLE: 'draw-circle',
  DRAW_FREE: 'draw-free',
  DRAW_TEXT: 'draw-text',
  EYE: 'eye',
  EYE_OFF: 'eye-off',
  FLASH: 'flash',
  FOLDER: 'folder',
  FOLDER_OPEN: 'folder-open',
  FULL_SCREEN: 'full-screen',
  HAND_CLOSED: 'HAND_CLOSED',
  HAND_OPEN: 'HAND_OPEN',
  HISTORY: 'history',
  INFO: 'info',
  LAYERS: 'layers',
  LINK: 'link',
  LIST: 'list',
  LOADING: 'loading',
  LOADING_SMALL: 'loading-small',
  LOCK_CLOSED: 'lock-closed',
  LOCK_OPEN: 'lock-open',
  MAP: 'map',
  MAP_LOCATION: 'map-location',
  MENU: 'menu',
  MEDIA_GOOGLE: 'media-google',
  MEDIA_FACEBOOK: 'media-facebook',
  MEDIA_APPLE: 'media-apple',
  MEDIA_MICROSOFT: 'media-microsoft',
  MEDIA_RECOVER_SENT: 'media-recover-sent',
  MEDIA_USER_NOT_ACTIVATED: 'media-user-not-activated',
  MEDIA_USER_ACTIVATION_EMAIL: 'media-user-activation-email',
  MEDIA_PASS_RECOVERY: 'media-pass-recover',
  MEDIA_PASS_RESET_OK: 'media-pass-reset-ok',
  MINUS_CIRCLE: 'minus-circle',
  MOVE: 'move',
  MOUSE_CLICK: 'mouse-click',
  PLAY: 'play',
  PAPER_CLIP: 'paper-clip',
  PENCIL: 'pencil',
  PIN: 'pin',
  PHOTO: 'photo',
  PRINTER: 'printer',
  QR_CODE: 'qr-code',
  QR_VALID: 'qr-valid',
  QR_NOT_VALID: 'qr_not_valid',
  RESET_ZOOM: 'reset-zoom',
  REFRESH: 'refresh',
  RULE: 'rule',
  SCISSORS: 'scissors',
  SEARCH: 'search',
  SHARING_UPDATE_ON: 'sharing_update_on',
  SHARING_UPDATE_OFF: 'sharing_update_off',
  SETTINGS: 'settings',
  SHARE: 'share',
  SORT_NAME_UP: 'sort-name-up',
  SORT_NAME_DOWN: 'sort-name-down',
  SORT_NUMBER_UP: 'sort-number-up',
  SORT_NUMBER_DOWN: 'sort-number-down',
  STATUS_DEADLINE: 'status-deadline',
  FILE_OCCURRENCES_ON_TIME: 'file-occurrences-on-time',
  FILE_OCCURRENCES_OVERDUE: 'file-occurrences-overdue',
  FILE_OCCURRENCES_FINISHED: 'file-occurrences-finished',
  TABLE: 'table',
  TAG: 'tag',
  THUMB_UP: 'thumb-up',
  THUMB_DOWN: 'thumb-down',
  TINT: 'tint',
  TRASH: 'trash',
  USER: 'user',
  USER_ADD: 'user-add',
  USER_REMOVED: 'user-removed',
  USER_GROUP: 'user-group',
  WRENCH: 'wrench',
  ZOOM_IN: 'zoom-in',
  ZOOM_OUT: 'zoom-out',
};

export const ProjectIcons = ({
  title = null,
  type,
  color = '#ffffff',
  innerColor = null,
  width = 20,
  height = 20,
  noFlex = false,
}) => {
  if (!type) return null;
  switch (type) {
    case iconTypes.ADD_CIRCLE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ADD_NEW:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M2.39465 14.2605V4.8855H1.45715V14.4949C1.45736 14.6813 1.53151 14.86 1.66333 14.9918C1.79514 15.1236 1.97386 15.1978 2.16028 15.198H11.7697V14.2605H2.39465Z"
              fill={color}
            />
            <path
              d="M5.20715 12.3855H4.26965V3.0105H3.33215V12.6199C3.33236 12.8063 3.40651 12.985 3.53833 13.1168C3.67014 13.2486 3.84886 13.3228 4.03528 13.323H13.6447V12.3855H5.20715Z"
              fill={color}
            />
            <path
              d="M14.8165 1.1355H5.91028C5.72386 1.13571 5.54514 1.20985 5.41332 1.34167C5.28151 1.47349 5.20736 1.65221 5.20715 1.83862V10.7449C5.20736 10.9313 5.28151 11.11 5.41332 11.2418C5.54514 11.3736 5.72386 11.4478 5.91028 11.448H14.8165C15.0029 11.4478 15.1817 11.3736 15.3135 11.2418C15.4453 11.11 15.5194 10.9313 15.5197 10.7449V1.83862C15.5194 1.65221 15.4453 1.47349 15.3135 1.34167C15.1817 1.20985 15.0029 1.13571 14.8165 1.1355V1.1355ZM14.5822 10.5105H6.14465V2.073H14.5822V10.5105Z"
              fill={color}
            />
            <path
              d="M9.89465 9.10425H10.8322V6.64331H13.2931V5.70581H10.8322V3.24487H9.89465V5.70581H7.43372V6.64331H9.89465V9.10425Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="15" height="15" fill="white" transform="translate(0.988403 0.666748)" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.ADD_FOLDER:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
          <path
            stroke="#dddddd"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M8 11h4m-2-2v4"
          />
        </SvgIcon>
      );
    case iconTypes.ADM:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ALERT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARCHIVE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
          <path
            fillRule="evenodd"
            d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_DOWN:
      return (
        <SvgIcon
          noFlex={noFlex}
          title={title}
          width={width}
          height={height}
          viewBox="0 0 10 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.58829 7.28507C4.63416 7.3517 4.69555 7.40617 4.76715 7.44381C4.83875 7.48144 4.91843 7.5011 4.99932 7.5011C5.08021 7.5011 5.15989 7.48144 5.2315 7.44381C5.3031 7.40617 5.36448 7.3517 5.41035 7.28507L9.91071 0.784562C9.9628 0.709584 9.99335 0.621765 9.99903 0.530645C10.0047 0.439525 9.98532 0.348589 9.94295 0.267718C9.90058 0.186847 9.83686 0.119134 9.75871 0.0719348C9.68056 0.024736 9.59097 -0.000143183 9.49967 6.19875e-07H0.49897C0.407884 0.000376854 0.318625 0.0255759 0.24079 0.0728878C0.162955 0.1202 0.0994899 0.187834 0.0572196 0.268518C0.0149493 0.349202 -0.00452694 0.439883 0.000885468 0.530808C0.00629787 0.621733 0.0363941 0.709462 0.0879376 0.784562L4.58829 7.28507Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_DOWN_ALT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_UP_ALT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M3.293 9.707a1 1 0 010-1.414l6-6a1 1 0 011.414 0l6 6a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L4.707 9.707a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_DOUBLE_LEFT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414zm-6 0a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 011.414 1.414L5.414 10l4.293 4.293a1 1 0 010 1.414z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_DOUBLE_RIGHT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10.293 15.707a1 1 0 010-1.414L14.586 10l-4.293-4.293a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M4.293 15.707a1 1 0 010-1.414L8.586 10 4.293 5.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_DOUBLE_DOWN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M15.707 4.293a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 011.414-1.414L10 8.586l4.293-4.293a1 1 0 011.414 0zm0 6a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L10 14.586l4.293-4.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_DOUBLE_UP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_SIMPLE_UP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ARROW_SIMPLE_DOWN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ASTERISK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M15.0652 10.0217C15.3986 10.2101 15.6142 10.4909 15.712 10.8641C15.8098 11.2373 15.7645 11.5906 15.5761 11.9239L14.8805 13.1196C14.6921 13.4529 14.4113 13.6685 14.0381 13.7663C13.6649 13.8641 13.3116 13.8188 12.9783 13.6304L10.087 11.9674V15.3043C10.087 15.6812 9.9493 16.0072 9.67394 16.2826C9.39857 16.558 9.07249 16.6957 8.69567 16.6957H7.30437C6.92756 16.6957 6.60147 16.558 6.32611 16.2826C6.05075 16.0072 5.91307 15.6812 5.91307 15.3043V11.9674L3.02176 13.6304C2.68843 13.8188 2.33517 13.8641 1.96198 13.7663C1.58879 13.6685 1.30799 13.4529 1.11959 13.1196L0.423936 11.9239C0.23553 11.5906 0.19024 11.2373 0.288066 10.8641C0.385892 10.4909 0.601472 10.2101 0.934805 10.0217L3.82611 8.34783L0.934805 6.67391C0.601472 6.48551 0.385892 6.20471 0.288066 5.83152C0.19024 5.45833 0.23553 5.10507 0.423936 4.77174L1.11959 3.57609C1.30799 3.24275 1.58879 3.02717 1.96198 2.92935C2.33517 2.83152 2.68843 2.87681 3.02176 3.06522L5.91307 4.72826V1.3913C5.91307 1.01449 6.05075 0.688406 6.32611 0.413043C6.60147 0.137681 6.92756 0 7.30437 0H8.69567C9.07249 0 9.39857 0.137681 9.67394 0.413043C9.9493 0.688406 10.087 1.01449 10.087 1.3913V4.72826L12.9783 3.06522C13.3116 2.87681 13.6649 2.83152 14.0381 2.92935C14.4113 3.02717 14.6921 3.24275 14.8805 3.57609L15.5761 4.77174C15.7645 5.10507 15.8098 5.45833 15.712 5.83152C15.6142 6.20471 15.3986 6.48551 15.0652 6.67391L12.1739 8.34783L15.0652 10.0217Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16.6957" fill="white" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.ASK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={width}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.BACK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M7.707 3.293a1 1 0 010 1.414L5.414 7H11a7 7 0 017 7v2a1 1 0 11-2 0v-2a5 5 0 00-5-5H5.414l2.293 2.293a1 1 0 11-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.BELL_ON:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M15.8333 11.3216V8.33329C15.8333 5.65246 14.0125 3.39413 11.5458 2.71496C11.3017 2.09996 10.705 1.66663 10 1.66663C9.295 1.66663 8.69833 2.09996 8.45417 2.71496C5.9875 3.39496 4.16667 5.65246 4.16667 8.33329V11.3216L2.74417 12.7441C2.66663 12.8214 2.60514 12.9132 2.56324 13.0143C2.52133 13.1154 2.49984 13.2238 2.5 13.3333V15C2.5 15.221 2.5878 15.4329 2.74408 15.5892C2.90036 15.7455 3.11232 15.8333 3.33333 15.8333H16.6667C16.8877 15.8333 17.0996 15.7455 17.2559 15.5892C17.4122 15.4329 17.5 15.221 17.5 15V13.3333C17.5002 13.2238 17.4787 13.1154 17.4368 13.0143C17.3949 12.9132 17.3334 12.8214 17.2558 12.7441L15.8333 11.3216ZM15.8333 14.1666H4.16667V13.6783L5.58917 12.2558C5.6667 12.1785 5.72819 12.0867 5.7701 11.9856C5.812 11.8845 5.83349 11.7761 5.83333 11.6666V8.33329C5.83333 6.03579 7.7025 4.16663 10 4.16663C12.2975 4.16663 14.1667 6.03579 14.1667 8.33329V11.6666C14.1667 11.8883 14.2542 12.1 14.4108 12.2558L15.8333 13.6783V14.1666ZM10 18.3333C10.5161 18.3339 11.0195 18.1738 11.4404 17.8751C11.8613 17.5764 12.1786 17.154 12.3483 16.6666H7.65167C7.82139 17.154 8.13873 17.5764 8.55959 17.8751C8.98045 18.1738 9.48392 18.3339 10 18.3333V18.3333Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.BELL_OFF:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.0001 18.3333C10.5161 18.3339 11.0196 18.1738 11.4405 17.8751C11.8613 17.5764 12.1787 17.154 12.3484 16.6666H7.65172C7.82144 17.154 8.13879 17.5764 8.55965 17.8751C8.98051 18.1738 9.48397 18.3339 10.0001 18.3333V18.3333ZM17.5001 15V13.3333C17.5002 13.2238 17.4787 13.1154 17.4368 13.0143C17.3949 12.9132 17.3334 12.8214 17.2559 12.7441L15.8334 11.3216V8.33329C15.8334 5.65246 14.0126 3.39413 11.5459 2.71496C11.3017 2.09996 10.7051 1.66663 10.0001 1.66663C9.29505 1.66663 8.69839 2.09996 8.45422 2.71496C7.35172 3.01829 6.40172 3.65496 5.66589 4.48746L3.08922 1.91079L1.91089 3.08913L16.9109 18.0891L18.0892 16.9108L16.9542 15.7758C17.1138 15.718 17.2517 15.6126 17.3493 15.4739C17.447 15.3351 17.4996 15.1696 17.5001 15V15ZM10.0001 4.16663C12.2976 4.16663 14.1667 6.03579 14.1667 8.33329V11.6666C14.1667 11.8883 14.2542 12.1 14.4109 12.2558L15.8334 13.6783V14.1666H15.3451L6.83922 5.66079C7.60005 4.75413 8.72589 4.16663 10.0001 4.16663ZM5.58922 12.2558C5.66676 12.1785 5.72825 12.0867 5.77015 11.9856C5.81206 11.8845 5.83355 11.7761 5.83339 11.6666V9.26746L4.22339 7.65746C4.19756 7.88079 4.16672 8.10329 4.16672 8.33329V11.3216L2.74422 12.7441C2.66669 12.8214 2.6052 12.9132 2.56329 13.0143C2.52139 13.1154 2.4999 13.2238 2.50006 13.3333V15C2.50006 15.221 2.58785 15.4329 2.74413 15.5892C2.90041 15.7455 3.11237 15.8333 3.33339 15.8333H12.3992L10.7326 14.1666H4.16672V13.6783L5.58922 12.2558Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.BOOKMARK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path d="M5 4a2 2 0 012-2h6a2 2 0 012 2v14l-5-2.5L5 18V4z" />
        </SvgIcon>
      );
    case iconTypes.BOMB:
      return (
        <SvgIcon
          title={title}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.207 3.45703L15.1758 5.48828L16.2109 6.52344C16.5781 6.89062 16.5781 7.48437 16.2109 7.84766L15.5313 8.52734C15.9922 9.54688 16.25 10.6797 16.25 11.8711C16.25 16.3594 12.6133 19.9961 8.125 19.9961C3.63672 19.9961 0 16.3633 0 11.875C0 7.38672 3.63672 3.75 8.125 3.75C9.31641 3.75 10.4492 4.00781 11.4688 4.46875L12.1484 3.78906C12.5156 3.42188 13.1094 3.42188 13.4727 3.78906L14.5078 4.82422L16.5391 2.79297L17.207 3.45703ZM19.5312 2.34375H18.5938C18.3359 2.34375 18.125 2.55469 18.125 2.8125C18.125 3.07031 18.3359 3.28125 18.5938 3.28125H19.5312C19.7891 3.28125 20 3.07031 20 2.8125C20 2.55469 19.7891 2.34375 19.5312 2.34375ZM17.1875 0C16.9297 0 16.7188 0.210938 16.7188 0.46875V1.40625C16.7188 1.66406 16.9297 1.875 17.1875 1.875C17.4453 1.875 17.6562 1.66406 17.6562 1.40625V0.46875C17.6562 0.210938 17.4453 0 17.1875 0ZM18.5117 2.14844L19.1758 1.48438C19.3594 1.30078 19.3594 1.00391 19.1758 0.820312C18.9922 0.636719 18.6953 0.636719 18.5117 0.820312L17.8477 1.48438C17.6641 1.66797 17.6641 1.96484 17.8477 2.14844C18.0352 2.33203 18.332 2.33203 18.5117 2.14844ZM15.8633 2.14844C16.0469 2.33203 16.3438 2.33203 16.5273 2.14844C16.7109 1.96484 16.7109 1.66797 16.5273 1.48438L15.8633 0.820312C15.6797 0.636719 15.3828 0.636719 15.1992 0.820312C15.0156 1.00391 15.0156 1.30078 15.1992 1.48438L15.8633 2.14844ZM18.5117 3.47656C18.3281 3.29297 18.0312 3.29297 17.8477 3.47656C17.6641 3.66016 17.6641 3.95703 17.8477 4.14062L18.5117 4.80469C18.6953 4.98828 18.9922 4.98828 19.1758 4.80469C19.3594 4.62109 19.3594 4.32422 19.1758 4.14062L18.5117 3.47656ZM4.375 10.625C4.375 9.24609 5.49609 8.125 6.875 8.125C7.21875 8.125 7.5 7.84375 7.5 7.5C7.5 7.15625 7.21875 6.875 6.875 6.875C4.80859 6.875 3.125 8.55859 3.125 10.625C3.125 10.9688 3.40625 11.25 3.75 11.25C4.09375 11.25 4.375 10.9688 4.375 10.625Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.BULLHORN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M13.7335 1.29211C11.6645 3.34102 8.62355 4.59514 5.69389 4.77153H1.34332C0.658107 4.78094 0.03864 5.36347 0 6.13183V8.09358C0.00934667 8.7785 0.57424 9.41519 1.34265 9.45386H3.08693C2.62077 11.0348 3.12151 12.6351 3.66227 14.2061C4.46448 14.9635 6.2994 14.8693 6.89744 13.8835C5.6238 12.8822 5.00344 10.1882 6.53892 9.52374C9.15605 9.82068 11.7489 11.1505 13.7335 12.9333C14.4158 12.9239 15.0362 12.3634 15.0762 11.5991V8.38155C16.4421 7.89645 16.166 6.19143 15.0762 5.84449V2.63543C15.0671 1.95057 14.5019 1.33145 13.7335 1.29277V1.29211H13.7335ZM13.7681 3.02725V11.2066C11.8504 9.7123 9.48096 8.70953 7.03655 8.25945V5.9751C9.43513 5.61414 11.781 4.50741 13.7681 3.02725V3.02725Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.CALENDAR:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.CALENDAR_DOWN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 23"
          fill="none"
        >
          <svg width="20" height="23" viewBox="0 0 20 23" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10 11.1111L5.55556 15.5556H8.88889V22.2222H11.1111V15.5556H14.4444L10 11.1111ZM17.7778 2.22222H16.6667V0H14.4444V2.22222H5.55556V0H3.33333V2.22222H2.22222C1.63285 2.22222 1.06762 2.45635 0.650874 2.8731C0.234126 3.28984 0 3.85507 0 4.44444V20C0 20.5894 0.234126 21.1546 0.650874 21.5713C1.06762 21.9881 1.63285 22.2222 2.22222 22.2222H6.66667V20H2.22222V7.77778H17.7778V20H13.3333V22.2222H17.7778C18.3671 22.2222 18.9324 21.9881 19.3491 21.5713C19.7659 21.1546 20 20.5894 20 20V4.44444C20 3.85507 19.7659 3.28984 19.3491 2.8731C18.9324 2.45635 18.3671 2.22222 17.7778 2.22222V2.22222Z"
              fill={color}
            />
          </svg>
        </SvgIcon>
      );
    case iconTypes.CALENDAR_UP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 23"
          fill="none"
        >
          <path
            d="M10 22.2222L14.4444 17.7778H11.1111V11.1111H8.88889V17.7778H5.55556L10 22.2222ZM17.7778 2.22222H16.6667V0H14.4444V2.22222H5.55556V0H3.33333V2.22222H2.22222C1.63285 2.22222 1.06762 2.45635 0.650874 2.8731C0.234126 3.28984 0 3.85507 0 4.44444V20C0 20.5894 0.234126 21.1546 0.650874 21.5713C1.06762 21.9881 1.63285 22.2222 2.22222 22.2222H5.55556V20H2.22222V7.77778H17.7778V20H14.4444V22.2222H17.7778C18.3671 22.2222 18.9324 21.9881 19.3491 21.5713C19.7659 21.1546 20 20.5894 20 20V4.44444C20 3.85507 19.7659 3.28984 19.3491 2.8731C18.9324 2.45635 18.3671 2.22222 17.7778 2.22222V2.22222Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.CHAT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path d="M2 5a2 2 0 012-2h7a2 2 0 012 2v4a2 2 0 01-2 2H9l-3 3v-3H4a2 2 0 01-2-2V5z" />
          <path d="M15 7v2a4 4 0 01-4 4H9.828l-1.766 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 002-2V9a2 2 0 00-2-2h-1z" />
        </SvgIcon>
      );
    case iconTypes.CAMERA:
      return (
        <SvgIcon
          title={title}
          width={width || 20}
          height={height || 18}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 18"
          fill="none"
        >
          <path
            d="M2 2H5L7 0H13L15 2H18C18.5304 2 19.0391 2.21071 19.4142 2.58579C19.7893 2.96086 20 3.46957 20 4V16C20 16.5304 19.7893 17.0391 19.4142 17.4142C19.0391 17.7893 18.5304 18 18 18H2C1.46957 18 0.960859 17.7893 0.585786 17.4142C0.210714 17.0391 0 16.5304 0 16V4C0 3.46957 0.210714 2.96086 0.585786 2.58579C0.960859 2.21071 1.46957 2 2 2ZM10 5C8.67392 5 7.40215 5.52678 6.46447 6.46447C5.52678 7.40215 5 8.67392 5 10C5 11.3261 5.52678 12.5979 6.46447 13.5355C7.40215 14.4732 8.67392 15 10 15C11.3261 15 12.5979 14.4732 13.5355 13.5355C14.4732 12.5979 15 11.3261 15 10C15 8.67392 14.4732 7.40215 13.5355 6.46447C12.5979 5.52678 11.3261 5 10 5ZM10 7C10.7956 7 11.5587 7.31607 12.1213 7.87868C12.6839 8.44129 13 9.20435 13 10C13 10.7956 12.6839 11.5587 12.1213 12.1213C11.5587 12.6839 10.7956 13 10 13C9.20435 13 8.44129 12.6839 7.87868 12.1213C7.31607 11.5587 7 10.7956 7 10C7 9.20435 7.31607 8.44129 7.87868 7.87868C8.44129 7.31607 9.20435 7 10 7Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.CHART_PIE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M4 14H8C8.28334 14 8.521 13.904 8.713 13.712C8.905 13.52 9.00067 13.2827 9 13C9 12.7167 8.904 12.479 8.712 12.287C8.52 12.095 8.28267 11.9993 8 12H4C3.71667 12 3.479 12.096 3.287 12.288C3.095 12.48 2.99934 12.7173 3 13C3 13.2833 3.096 13.521 3.288 13.713C3.48 13.905 3.71734 14.0007 4 14ZM7 10H11C11.2833 10 11.521 9.904 11.713 9.712C11.905 9.52 12.0007 9.28267 12 9C12 8.71667 11.904 8.479 11.712 8.287C11.52 8.095 11.2827 7.99934 11 8H7C6.71667 8 6.479 8.096 6.287 8.288C6.095 8.48 5.99934 8.71734 6 9C6 9.28334 6.096 9.521 6.288 9.713C6.48 9.905 6.71734 10.0007 7 10ZM10 6H14C14.2833 6 14.521 5.904 14.713 5.712C14.905 5.52 15.0007 5.28267 15 5C15 4.71667 14.904 4.479 14.712 4.287C14.52 4.095 14.2827 3.99934 14 4H10C9.71667 4 9.479 4.096 9.287 4.288C9.095 4.48 8.99934 4.71734 9 5C9 5.28334 9.096 5.521 9.288 5.713C9.48 5.905 9.71734 6.00067 10 6ZM2 18C1.45 18 0.979002 17.804 0.587002 17.412C0.195002 17.02 -0.000664969 16.5493 1.69779e-06 16V2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06H16C16.55 1.69779e-06 17.021 0.196002 17.413 0.588002C17.805 0.980002 18.0007 1.45067 18 2V16C18 16.55 17.804 17.021 17.412 17.413C17.02 17.805 16.5493 18.0007 16 18H2ZM2 16H16V2H2V16Z"
            fill={color}
          />
          {/*<path*/}
          {/*  d="M4 14H8C8.28334 14 8.521 13.904 8.713 13.712C8.905 13.52 9.00067 13.2827 9 13C9 12.7167 8.904 12.479 8.712 12.287C8.52 12.095 8.28267 11.9993 8 12H4C3.71667 12 3.479 12.096 3.287 12.288C3.095 12.48 2.99934 12.7173 3 13C3 13.2833 3.096 13.521 3.288 13.713C3.48 13.905 3.71734 14.0007 4 14ZM7 10H11C11.2833 10 11.521 9.904 11.713 9.712C11.905 9.52 12.0007 9.28267 12 9C12 8.71667 11.904 8.479 11.712 8.287C11.52 8.095 11.2827 7.99934 11 8H7C6.71667 8 6.479 8.096 6.287 8.288C6.095 8.48 5.99934 8.71734 6 9C6 9.28334 6.096 9.521 6.288 9.713C6.48 9.905 6.71734 10.0007 7 10ZM10 6H14C14.2833 6 14.521 5.904 14.713 5.712C14.905 5.52 15.0007 5.28267 15 5C15 4.71667 14.904 4.479 14.712 4.287C14.52 4.095 14.2827 3.99934 14 4H10C9.71667 4 9.479 4.096 9.287 4.288C9.095 4.48 8.99934 4.71734 9 5C9 5.28334 9.096 5.521 9.288 5.713C9.48 5.905 9.71734 6.00067 10 6ZM2 18C1.45 18 0.979002 17.804 0.587002 17.412C0.195002 17.02 -0.000664969 16.5493 1.69779e-06 16V2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06H16C16.55 1.69779e-06 17.021 0.196002 17.413 0.588002C17.805 0.980002 18.0007 1.45067 18 2V16C18 16.55 17.804 17.021 17.412 17.413C17.02 17.805 16.5493 18.0007 16 18H2Z"*/}
          {/*  fill={color}*/}
          {/*/>*/}
        </SvgIcon>
      );
    case iconTypes.GANTT_CHART:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M4 14H8C8.28334 14 8.521 13.904 8.713 13.712C8.905 13.52 9.00067 13.2827 9 13C9 12.7167 8.904 12.479 8.712 12.287C8.52 12.095 8.28267 11.9993 8 12H4C3.71667 12 3.479 12.096 3.287 12.288C3.095 12.48 2.99934 12.7173 3 13C3 13.2833 3.096 13.521 3.288 13.713C3.48 13.905 3.71734 14.0007 4 14ZM7 10H11C11.2833 10 11.521 9.904 11.713 9.712C11.905 9.52 12.0007 9.28267 12 9C12 8.71667 11.904 8.479 11.712 8.287C11.52 8.095 11.2827 7.99934 11 8H7C6.71667 8 6.479 8.096 6.287 8.288C6.095 8.48 5.99934 8.71734 6 9C6 9.28334 6.096 9.521 6.288 9.713C6.48 9.905 6.71734 10.0007 7 10ZM10 6H14C14.2833 6 14.521 5.904 14.713 5.712C14.905 5.52 15.0007 5.28267 15 5C15 4.71667 14.904 4.479 14.712 4.287C14.52 4.095 14.2827 3.99934 14 4H10C9.71667 4 9.479 4.096 9.287 4.288C9.095 4.48 8.99934 4.71734 9 5C9 5.28334 9.096 5.521 9.288 5.713C9.48 5.905 9.71734 6.00067 10 6ZM2 18C1.45 18 0.979002 17.804 0.587002 17.412C0.195002 17.02 -0.000664969 16.5493 1.69779e-06 16V2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06H16C16.55 1.69779e-06 17.021 0.196002 17.413 0.588002C17.805 0.980002 18.0007 1.45067 18 2V16C18 16.55 17.804 17.021 17.412 17.413C17.02 17.805 16.5493 18.0007 16 18H2ZM2 16H16V2H2V16Z"
            fill={color}
          />
          {/* <path*/}
          {/*  d="M4 14H8C8.28334 14 8.521 13.904 8.713 13.712C8.905 13.52 9.00067 13.2827 9 13C9 12.7167 8.904 12.479 8.712 12.287C8.52 12.095 8.28267 11.9993 8 12H4C3.71667 12 3.479 12.096 3.287 12.288C3.095 12.48 2.99934 12.7173 3 13C3 13.2833 3.096 13.521 3.288 13.713C3.48 13.905 3.71734 14.0007 4 14ZM7 10H11C11.2833 10 11.521 9.904 11.713 9.712C11.905 9.52 12.0007 9.28267 12 9C12 8.71667 11.904 8.479 11.712 8.287C11.52 8.095 11.2827 7.99934 11 8H7C6.71667 8 6.479 8.096 6.287 8.288C6.095 8.48 5.99934 8.71734 6 9C6 9.28334 6.096 9.521 6.288 9.713C6.48 9.905 6.71734 10.0007 7 10ZM10 6H14C14.2833 6 14.521 5.904 14.713 5.712C14.905 5.52 15.0007 5.28267 15 5C15 4.71667 14.904 4.479 14.712 4.287C14.52 4.095 14.2827 3.99934 14 4H10C9.71667 4 9.479 4.096 9.287 4.288C9.095 4.48 8.99934 4.71734 9 5C9 5.28334 9.096 5.521 9.288 5.713C9.48 5.905 9.71734 6.00067 10 6ZM2 18C1.45 18 0.979002 17.804 0.587002 17.412C0.195002 17.02 -0.000664969 16.5493 1.69779e-06 16V2C1.69779e-06 1.45 0.196002 0.979002 0.588002 0.587002C0.980002 0.195002 1.45067 -0.000664969 2 1.69779e-06H16C16.55 1.69779e-06 17.021 0.196002 17.413 0.588002C17.805 0.980002 18.0007 1.45067 18 2V16C18 16.55 17.804 17.021 17.412 17.413C17.02 17.805 16.5493 18.0007 16 18H2Z"*/}
          {/*  fill={color}*/}
          {/* />*/}
        </SvgIcon>
      );
    case iconTypes.CHECK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.CHECK_SQUARE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M7.5 9.16671L10 11.6667L18.3333 3.33337"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.5 10V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H13.3333"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </SvgIcon>
      );
    case iconTypes.CHECK_SQUARE_EMPTY:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 22 22"
          fill="none"
        >
          <path
            d="M19.3333 1H2.66667C2.22464 1 1.80072 1.17559 1.48816 1.48816C1.17559 1.80072 1 2.22464 1 2.66667V19.3333C1 19.7754 1.17559 20.1993 1.48816 20.5118C1.80072 20.8244 2.22464 21 2.66667 21H19.3333C19.7754 21 20.1993 20.8244 20.5118 20.5118C20.8244 20.1993 21 19.7754 21 19.3333V2.66667C21 2.22464 20.8244 1.80072 20.5118 1.48816C20.1993 1.17559 19.7754 1 19.3333 1Z"
            stroke={color}
            strokeWidth="2"
          />
        </SvgIcon>
      );
    case iconTypes.CLOCK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 22 22"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.CLOUD:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 2C6.68024 2.00414 5.40548 2.48014 4.406 3.342C3.64 4.002 3.085 4.862 2.942 5.725C1.266 6.095 0 7.555 0 9.318C0 11.366 1.708 13 3.781 13H12.687C14.502 13 16 11.57 16 9.773C16 8.137 14.758 6.804 13.166 6.579C12.923 3.999 10.69 2 8 2ZM10.354 8.854L8.354 10.854C8.30755 10.9006 8.25238 10.9375 8.19163 10.9627C8.13089 10.9879 8.06577 11.0009 8 11.0009C7.93423 11.0009 7.86911 10.9879 7.80837 10.9627C7.74762 10.9375 7.69245 10.9006 7.646 10.854L5.646 8.854C5.59951 8.80751 5.56264 8.75232 5.53748 8.69158C5.51232 8.63084 5.49937 8.56574 5.49937 8.5C5.49937 8.43426 5.51232 8.36916 5.53748 8.30842C5.56264 8.24768 5.59951 8.19249 5.646 8.146C5.73989 8.05211 5.86722 7.99937 6 7.99937C6.06574 7.99937 6.13084 8.01232 6.19158 8.03748C6.25232 8.06264 6.30751 8.09951 6.354 8.146L7.5 9.293V5.5C7.5 5.36739 7.55268 5.24021 7.64645 5.14645C7.74021 5.05268 7.86739 5 8 5C8.13261 5 8.25979 5.05268 8.35355 5.14645C8.44732 5.24021 8.5 5.36739 8.5 5.5V9.293L9.646 8.146C9.73989 8.05211 9.86722 7.99937 10 7.99937C10.1328 7.99937 10.2601 8.05211 10.354 8.146C10.4479 8.23989 10.5006 8.36722 10.5006 8.5C10.5006 8.63278 10.4479 8.76011 10.354 8.854V8.854Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.CLOUD_DOWN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.75 0H9.25C9.66563 0 10 0.334375 10 0.75V6H12.7406C13.2969 6 13.575 6.67188 13.1812 7.06563L8.42813 11.8219C8.19375 12.0562 7.80937 12.0562 7.575 11.8219L2.81562 7.06563C2.42187 6.67188 2.7 6 3.25625 6H6V0.75C6 0.334375 6.33437 0 6.75 0ZM16 11.75V15.25C16 15.6656 15.6656 16 15.25 16H0.75C0.334375 16 0 15.6656 0 15.25V11.75C0 11.3344 0.334375 11 0.75 11H5.33437L6.86562 12.5312C7.49375 13.1594 8.50625 13.1594 9.13437 12.5312L10.6656 11H15.25C15.6656 11 16 11.3344 16 11.75ZM12.125 14.5C12.125 14.1562 11.8438 13.875 11.5 13.875C11.1562 13.875 10.875 14.1562 10.875 14.5C10.875 14.8438 11.1562 15.125 11.5 15.125C11.8438 15.125 12.125 14.8438 12.125 14.5ZM14.125 14.5C14.125 14.1562 13.8438 13.875 13.5 13.875C13.1562 13.875 12.875 14.1562 12.875 14.5C12.875 14.8438 13.1562 15.125 13.5 15.125C13.8438 15.125 14.125 14.8438 14.125 14.5Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.CLOUD_UP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.25 12H6.75C6.33437 12 6 11.6656 6 11.25V5.99998H3.25938C2.70313 5.99998 2.425 5.3281 2.81875 4.93435L7.57188 0.178101C7.80625 -0.0562744 8.19063 -0.0562744 8.425 0.178101L13.1812 4.93435C13.575 5.3281 13.2969 5.99998 12.7406 5.99998H10V11.25C10 11.6656 9.66563 12 9.25 12ZM16 11.75V15.25C16 15.6656 15.6656 16 15.25 16H0.75C0.334375 16 0 15.6656 0 15.25V11.75C0 11.3344 0.334375 11 0.75 11H5V11.25C5 12.2156 5.78438 13 6.75 13H9.25C10.2156 13 11 12.2156 11 11.25V11H15.25C15.6656 11 16 11.3344 16 11.75ZM12.125 14.5C12.125 14.1562 11.8438 13.875 11.5 13.875C11.1562 13.875 10.875 14.1562 10.875 14.5C10.875 14.8437 11.1562 15.125 11.5 15.125C11.8438 15.125 12.125 14.8437 12.125 14.5ZM14.125 14.5C14.125 14.1562 13.8438 13.875 13.5 13.875C13.1562 13.875 12.875 14.1562 12.875 14.5C12.875 14.8437 13.1562 15.125 13.5 15.125C13.8438 15.125 14.125 14.8437 14.125 14.5Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.COPY:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.6 4.80005H1.6C0.7176 4.80005 0 5.51765 0 6.40005V14.4C0 15.2824 0.7176 16 1.6 16H9.6C10.4824 16 11.2 15.2824 11.2 14.4V6.40005C11.2 5.51765 10.4824 4.80005 9.6 4.80005Z"
            fill={color}
          />
          <path
            d="M14.4 0H6.40005C5.9757 0 5.56874 0.168571 5.26868 0.468629C4.96862 0.768687 4.80005 1.17565 4.80005 1.6V3.2H11.2C11.6244 3.2 12.0314 3.36857 12.3314 3.66863C12.6315 3.96869 12.8 4.37565 12.8 4.8V11.2H14.4C14.8244 11.2 15.2314 11.0314 15.5314 10.7314C15.8315 10.4313 16 10.0243 16 9.6V1.6C16 1.17565 15.8315 0.768687 15.5314 0.468629C15.2314 0.168571 14.8244 0 14.4 0Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.CANCEL:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.CUBE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M11 17a1 1 0 001.447.894l4-2A1 1 0 0017 15V9.236a1 1 0 00-1.447-.894l-4 2a1 1 0 00-.553.894V17zM15.211 6.276a1 1 0 000-1.788l-4.764-2.382a1 1 0 00-.894 0L4.789 4.488a1 1 0 000 1.788l4.764 2.382a1 1 0 00.894 0l4.764-2.382zM4.447 8.342A1 1 0 003 9.236V15a1 1 0 00.553.894l4 2A1 1 0 009 17v-5.764a1 1 0 00-.553-.894l-4-2z" />
        </SvgIcon>
      );
    case iconTypes.CUBE_WIRE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M9.504 1.132a1 1 0 01.992 0l1.75 1a1 1 0 11-.992 1.736L10 3.152l-1.254.716a1 1 0 11-.992-1.736l1.75-1zM5.618 4.504a1 1 0 01-.372 1.364L5.016 6l.23.132a1 1 0 11-.992 1.736L4 7.723V8a1 1 0 01-2 0V6a.996.996 0 01.52-.878l1.734-.99a1 1 0 011.364.372zm8.764 0a1 1 0 011.364-.372l1.733.99A1.002 1.002 0 0118 6v2a1 1 0 11-2 0v-.277l-.254.145a1 1 0 11-.992-1.736l.23-.132-.23-.132a1 1 0 01-.372-1.364zm-7 4a1 1 0 011.364-.372L10 8.848l1.254-.716a1 1 0 11.992 1.736L11 10.58V12a1 1 0 11-2 0v-1.42l-1.246-.712a1 1 0 01-.372-1.364zM3 11a1 1 0 011 1v1.42l1.246.712a1 1 0 11-.992 1.736l-1.75-1A1 1 0 012 14v-2a1 1 0 011-1zm14 0a1 1 0 011 1v2a1 1 0 01-.504.868l-1.75 1a1 1 0 11-.992-1.736L16 13.42V12a1 1 0 011-1zm-9.618 5.504a1 1 0 011.364-.372l.254.145V16a1 1 0 112 0v.277l.254-.145a1 1 0 11.992 1.736l-1.735.992a.995.995 0 01-1.022 0l-1.735-.992a1 1 0 01-.372-1.364z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.CUBES:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.2688 7.8188L12.25 6.68755V3.29692C12.25 2.82817 11.9594 2.40942 11.5188 2.2438L8.39375 1.07192C8.14063 0.975049 7.85938 0.975049 7.60313 1.07192L4.47813 2.2438C4.0375 2.40942 3.74688 2.82817 3.74688 3.29692V6.68755L0.728125 7.8188C0.290625 7.98442 0 8.40317 0 8.87192V12.3125C0 12.7375 0.240625 13.1282 0.621875 13.3188L3.74688 14.8813C4.0625 15.0407 4.4375 15.0407 4.75313 14.8813L8 13.2563L11.2469 14.8813C11.5625 15.0407 11.9375 15.0407 12.2531 14.8813L15.3781 13.3188C15.7594 13.1282 16 12.7375 16 12.3125V8.87192C16 8.40317 15.7094 7.98442 15.2688 7.8188V7.8188ZM11.1875 6.71255L8.53125 7.70942V5.57817L11.1875 4.42192V6.71255ZM4.8125 3.25317L8 2.05942L11.1875 3.25317V3.27192L8 4.56567L4.8125 3.27192V3.25317ZM7.4375 12.35L4.78125 13.6782V11.2063L7.4375 9.9938V12.35ZM7.4375 8.85005L4.25 10.1438L1.0625 8.85005V8.8313L4.25 7.63755L7.4375 8.8313V8.85005ZM14.9375 12.35L12.2812 13.6782V11.2063L14.9375 9.9938V12.35ZM14.9375 8.85005L11.75 10.1438L8.5625 8.85005V8.8313L11.75 7.63755L14.9375 8.8313V8.85005Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.DOCUMENT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.DRAW_ARROW:
      return (
        <SvgIcon
          noFlex={noFlex}
          title={title}
          width={21}
          height={21}
          viewBox="0 0 21 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.9679 20.0266H19.3536C19.5322 20.0266 19.7034 19.9557 19.8297 19.8294C19.9559 19.7032 20.0269 19.5319 20.0269 19.3534V13.9676C20.0271 13.8343 19.9877 13.7039 19.9138 13.593C19.8398 13.4821 19.7346 13.3956 19.6114 13.3445C19.4883 13.2935 19.3527 13.2801 19.222 13.3062C19.0912 13.3323 18.9712 13.3966 18.877 13.491L16.6608 15.7086L0.980135 0.026612L0.0268562 0.979891L15.7088 16.6605L13.4912 18.8768C13.3968 18.9709 13.3325 19.091 13.3065 19.2217C13.2804 19.3525 13.2937 19.488 13.3448 19.6112C13.3958 19.7343 13.4823 19.8396 13.5932 19.9135C13.7042 19.9875 13.8346 20.0268 13.9679 20.0266Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.DRAW_CIRCLE:
      return (
        <SvgIcon
          noFlex={noFlex}
          title={title}
          width={22}
          height={22}
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.4486 3.22077L18.7795 6.55175M11.0072 14.324L20.3173 4.98064C20.7546 4.54334 21.0003 3.95024 21.0003 3.3318C21.0003 2.71337 20.7546 2.12027 20.3173 1.68297C19.88 1.24567 19.2869 1 18.6685 1C18.0501 1 17.457 1.24567 17.0197 1.68297L7.67627 10.9931V14.324H11.0072Z"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.67597 5.51904C5.72822 5.79656 3.95819 6.80241 2.72293 8.3337C1.48766 9.86499 0.87909 11.8078 1.01996 13.7701C1.16084 15.7325 2.04068 17.5684 3.482 18.9076C4.92333 20.2467 6.81888 20.9894 8.7863 20.9859C10.6554 20.9861 12.462 20.3127 13.875 19.0892C15.288 17.8656 16.2127 16.1739 16.4797 14.3239"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </SvgIcon>
      );
    case iconTypes.DRAW_FREE:
      return (
        <SvgIcon
          noFlex={noFlex}
          title={title}
          width={18}
          height={20}
          viewBox="0 0 18 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16.0048 0.664246C16.5476 0.902803 17.1418 1.3542 17.1418 2.14273C17.1418 2.91125 16.5847 3.36694 16.0562 3.6155C15.5205 3.86548 14.8134 4.00976 14.0577 4.10118C12.5435 4.28546 10.5437 4.28546 8.60806 4.28546H8.57091C6.59103 4.28546 4.67543 4.28546 3.25552 4.4583C2.53842 4.54544 2.01702 4.66972 1.69133 4.82114C1.59621 4.85921 1.50973 4.91605 1.43706 4.98827L1.43277 4.99399C1.44991 5.03113 1.53991 5.17969 1.96845 5.35396C2.47985 5.56395 3.27123 5.71394 4.28546 5.71394V7.14243C3.15553 7.14243 2.16273 6.97958 1.4242 6.67531C0.751383 6.39962 0 5.87108 0 4.9997C0 4.23117 0.557109 3.77549 1.08565 3.52693C1.62133 3.27695 2.32843 3.13267 3.0841 3.04125C4.5983 2.85697 6.59818 2.85697 8.53377 2.85697H8.57091C10.5508 2.85697 12.4664 2.85697 13.8863 2.68412C14.6034 2.59699 15.1248 2.47271 15.4505 2.32129C15.5456 2.28319 15.6321 2.22635 15.7048 2.15416L15.7105 2.14844L15.7076 2.14559C15.6264 2.06889 15.5308 2.00916 15.4262 1.96988C15.0748 1.81418 14.512 1.6899 13.7435 1.60276C12.2207 1.42849 10.1522 1.42849 7.96667 1.42849C7.77724 1.42849 7.59557 1.35324 7.46162 1.21929C7.32767 1.08534 7.25242 0.903672 7.25242 0.714243C7.25242 0.524814 7.32767 0.343143 7.46162 0.209197C7.59557 0.0752503 7.77724 0 7.96667 0H8.00238C10.1451 0 12.2921 2.12861e-08 13.9049 0.182846C14.7091 0.274269 15.4476 0.417118 16.0048 0.664246ZM7.85524 7.14243C7.66581 7.14243 7.48414 7.21768 7.3502 7.35163C7.21625 7.48557 7.141 7.66724 7.141 7.85667V13.5706C7.14107 13.6944 7.10899 13.816 7.0479 13.9236C6.98681 14.0312 6.89881 14.1211 6.79252 14.1845C6.68623 14.2479 6.5653 14.2825 6.44159 14.2851C6.31787 14.2877 6.1956 14.2581 6.08678 14.1991L4.54687 13.3678C4.40088 13.2889 4.23976 13.242 4.07423 13.2302C3.90871 13.2184 3.74257 13.242 3.58688 13.2995C3.43119 13.3569 3.28953 13.4469 3.17131 13.5633C3.05309 13.6798 2.96103 13.8201 2.90125 13.9749L6.23677 16.2305C7.28528 16.8019 8.06809 17.5947 8.55377 18.1803C8.79804 18.4746 9.13374 18.6046 9.41515 18.5617L12.1293 18.1503C12.2687 18.1291 12.3988 18.067 12.503 17.9719C12.6073 17.8768 12.681 17.753 12.715 17.6161L13.5049 14.4477C13.5771 14.1583 13.5881 13.857 13.5371 13.5631C13.4862 13.2692 13.3744 12.9892 13.209 12.741C13.0436 12.4928 12.8282 12.2818 12.5766 12.1216C12.325 11.9614 12.0428 11.8555 11.7479 11.8107L9.17659 11.4193C9.00801 11.3934 8.85426 11.308 8.74317 11.1786C8.63208 11.0491 8.57098 10.8842 8.57091 10.7136V7.85667C8.57091 7.66724 8.49566 7.48557 8.36172 7.35163C8.22777 7.21768 8.04467 7.14243 7.85524 7.14243ZM5.71394 7.85667C5.71394 7.28838 5.93969 6.74337 6.34153 6.34153C6.74337 5.93969 7.28838 5.71394 7.85667 5.71394C8.42496 5.71394 8.96997 5.93969 9.37181 6.34153C9.77365 6.74337 9.9994 7.28838 9.9994 7.85667V10.0994L11.9636 10.3994C12.4549 10.4741 12.9253 10.6506 13.3446 10.9175C13.7638 11.1844 14.1228 11.5359 14.3984 11.9495C14.6741 12.3631 14.8603 12.8297 14.9453 13.3194C15.0303 13.8091 15.0121 14.3111 14.892 14.7934L14.102 17.9618C13.9997 18.3721 13.7783 18.7429 13.4656 19.0276C13.1529 19.3123 12.763 19.4981 12.345 19.5617L9.63085 19.9759C8.76233 20.1059 7.95524 19.6945 7.4567 19.0931C7.03244 18.5817 6.37533 17.9246 5.52967 17.4704C5.50858 17.459 5.48808 17.4467 5.46824 17.4332L1.95417 15.0577C1.756 14.9234 1.60314 14.7322 1.51568 14.5094C1.42823 14.2865 1.41028 14.0424 1.4642 13.8092C1.554 13.4196 1.73257 13.0561 1.98598 12.7469C2.23939 12.4378 2.56079 12.1913 2.92511 12.0268C3.28944 11.8622 3.68685 11.7841 4.08635 11.7984C4.48585 11.8127 4.87664 11.9191 5.22826 12.1093L5.71394 12.3735V7.85667Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.DRAW_TEXT:
      return (
        <SvgIcon
          noFlex={noFlex}
          title={title}
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0.9375C0 0.68886 0.0987719 0.450403 0.274587 0.274587C0.450403 0.0987719 0.68886 0 0.9375 0H13.4375C13.6861 0 13.9246 0.0987719 14.1004 0.274587C14.2762 0.450403 14.375 0.68886 14.375 0.9375V2.8125C14.375 3.06114 14.2762 3.2996 14.1004 3.47541C13.9246 3.65123 13.6861 3.75 13.4375 3.75C13.1889 3.75 12.9504 3.65123 12.7746 3.47541C12.5988 3.2996 12.5 3.06114 12.5 2.8125V1.875H8.125V11.5075C7.71195 12.407 7.49872 13.3852 7.5 14.375C7.5 15.5 7.77 16.5625 8.25 17.5H4.6875C4.43886 17.5 4.2004 17.4012 4.02459 17.2254C3.84877 17.0496 3.75 16.8111 3.75 16.5625C3.75 16.3139 3.84877 16.0754 4.02459 15.8996C4.2004 15.7238 4.43886 15.625 4.6875 15.625H6.25V1.875H1.875V2.8125C1.875 3.06114 1.77623 3.2996 1.60041 3.47541C1.4246 3.65123 1.18614 3.75 0.9375 3.75C0.68886 3.75 0.450403 3.65123 0.274587 3.47541C0.0987719 3.2996 0 3.06114 0 2.8125V0.9375ZM20 14.375C20 15.8668 19.4074 17.2976 18.3525 18.3525C17.2976 19.4074 15.8668 20 14.375 20C12.8832 20 11.4524 19.4074 10.3975 18.3525C9.34263 17.2976 8.75 15.8668 8.75 14.375C8.75 12.8832 9.34263 11.4524 10.3975 10.3975C11.4524 9.34263 12.8832 8.75 14.375 8.75C15.8668 8.75 17.2976 9.34263 18.3525 10.3975C19.4074 11.4524 20 12.8832 20 14.375ZM15 11.875C15 11.7092 14.9342 11.5503 14.8169 11.4331C14.6997 11.3158 14.5408 11.25 14.375 11.25C14.2092 11.25 14.0503 11.3158 13.9331 11.4331C13.8158 11.5503 13.75 11.7092 13.75 11.875V13.75H11.875C11.7092 13.75 11.5503 13.8158 11.4331 13.9331C11.3158 14.0503 11.25 14.2092 11.25 14.375C11.25 14.5408 11.3158 14.6997 11.4331 14.8169C11.5503 14.9342 11.7092 15 11.875 15H13.75V16.875C13.75 17.0408 13.8158 17.1997 13.9331 17.3169C14.0503 17.4342 14.2092 17.5 14.375 17.5C14.5408 17.5 14.6997 17.4342 14.8169 17.3169C14.9342 17.1997 15 17.0408 15 16.875V15H16.875C17.0408 15 17.1997 14.9342 17.3169 14.8169C17.4342 14.6997 17.5 14.5408 17.5 14.375C17.5 14.2092 17.4342 14.0503 17.3169 13.9331C17.1997 13.8158 17.0408 13.75 16.875 13.75H15V11.875Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.EYE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
          <path
            fillRule="evenodd"
            d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.EYE_OFF:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 16"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M3.707 2.293a1 1 0 00-1.414 1.414l14 14a1 1 0 001.414-1.414l-1.473-1.473A10.014 10.014 0 0019.542 10C18.268 5.943 14.478 3 10 3a9.958 9.958 0 00-4.512 1.074l-1.78-1.781zm4.261 4.26l1.514 1.515a2.003 2.003 0 012.45 2.45l1.514 1.514a4 4 0 00-5.478-5.478z"
            clipRule="evenodd"
          />
          <path d="M12.454 16.697L9.75 13.992a4 4 0 01-3.742-3.741L2.335 6.578A9.98 9.98 0 00.458 10c1.274 4.057 5.065 7 9.542 7 .847 0 1.669-.105 2.454-.303z" />
        </SvgIcon>
      );
    case iconTypes.FLASH:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.FOLDER:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
          fill={color}
        >
          <path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" />
        </SvgIcon>
      );
    case iconTypes.FOLDER_OPEN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          xmlns="http://www.w3.org/2000/svg"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z"
            clipRule="evenodd"
          />
          <path d="M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z" />
        </SvgIcon>
      );
    case iconTypes.FULL_SCREEN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M3 5a2 2 0 012-2h10a2 2 0 012 2v8a2 2 0 01-2 2h-2.22l.123.489.804.804A1 1 0 0113 18H7a1 1 0 01-.707-1.707l.804-.804L7.22 15H5a2 2 0 01-2-2V5zm5.771 7H5V5h10v7H8.771z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.HAND_CLOSED:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.7857 2.28947C14.524 2.29336 14.2643 2.3359 14.015 2.41571C13.8888 1.59185 12.9852 0.96731 11.8424 0.96731C11.496 0.955855 11.1507 1.01228 10.8259 1.13341C10.6194 0.769697 10.3151 0.471106 9.94753 0.271478C9.57998 0.0718492 9.16386 -0.020835 8.74633 0.00392833C8.38162 -0.0123002 8.01831 0.0588182 7.68664 0.211364C7.35497 0.36391 7.06453 0.59347 6.8395 0.880938C6.45959 0.655756 6.0254 0.538594 5.58378 0.542093C5.05464 0.507079 4.53287 0.680876 4.13041 1.02619C3.72796 1.3715 3.47691 1.86082 3.43112 2.38913V2.99373C2.72685 3.2595 0.700429 4.18966 0.168908 6.20944C-0.362613 8.22922 0.394804 11.5246 1.95615 14.0361C3.00575 15.6724 4.33221 17.1135 5.87612 18.2949C5.97861 18.3688 6.10189 18.4084 6.22825 18.4078H13.0982C13.2304 18.4064 13.3586 18.3621 13.4636 18.2816C14.6567 17.1821 15.5195 15.7717 15.9551 14.2088C16.7085 12.151 17.0603 9.96777 16.9916 7.77742V4.12322C16.9377 3.58942 16.6763 3.09814 16.2637 2.75516C15.8512 2.41218 15.3204 2.24495 14.7857 2.28947V2.28947ZM15.7956 7.77742C15.8681 9.84806 15.5364 11.913 14.819 13.8567C14.443 15.1141 13.7735 16.2642 12.8656 17.2119H6.40099C5.04955 16.1423 3.88246 14.8585 2.94611 13.4115C1.37147 10.847 0.952901 7.94353 1.29839 6.50842C1.47953 6.01107 1.76291 5.55722 2.13026 5.17614C2.4976 4.79507 2.94075 4.49522 3.43112 4.29596V9.37863C3.43112 9.53722 3.49412 9.68932 3.60626 9.80145C3.7184 9.91359 3.87049 9.97659 4.02908 9.97659C4.18767 9.97659 4.33976 9.91359 4.4519 9.80145C4.56404 9.68932 4.62704 9.53722 4.62704 9.37863V2.38913C4.62704 2.07686 5.01904 1.72473 5.59707 1.72473C6.1751 1.72473 6.58703 2.07022 6.58703 2.38913V6.18951H7.78295V1.67158C7.78295 1.48554 8.1683 1.19985 8.75297 1.19985C9.33765 1.19985 9.76951 1.51876 9.76951 1.69815V6.27588H10.9654V2.46221L11.0784 2.38249C11.3128 2.23543 11.5857 2.16142 11.8624 2.16988C12.4803 2.16988 12.859 2.46221 12.859 2.62167V6.94028H14.0615V3.70464C14.2806 3.55568 14.5408 3.47901 14.8057 3.48539C15.3771 3.48539 15.8156 3.82424 15.8156 4.10993L15.7956 7.77742Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.HAND_OPEN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.9932 5.80045C19.9953 5.44117 19.9059 5.08726 19.7335 4.77205C19.5611 4.45684 19.3113 4.1907 19.0076 3.99869C18.7039 3.80669 18.3564 3.69512 17.9977 3.67452C17.639 3.65391 17.281 3.72493 16.9573 3.8809C16.9359 3.51908 16.8243 3.16838 16.6326 2.86076C16.441 2.55313 16.1754 2.29838 15.86 2.11973C15.5447 1.94107 15.1896 1.84419 14.8272 1.83793C14.4648 1.83167 14.1066 1.91622 13.7853 2.08387C13.749 1.56356 13.5323 1.07222 13.1725 0.694624C12.8127 0.317024 12.3324 0.0768479 11.8145 0.015533C11.2965 -0.045782 10.7734 0.0756103 10.3354 0.358765C9.8974 0.641921 9.57196 1.06908 9.41523 1.56654C9.07387 1.36181 8.68333 1.25359 8.28528 1.25342C7.9924 1.25431 7.70258 1.313 7.43242 1.42611C7.16226 1.53922 6.91708 1.70453 6.71093 1.91258C6.50478 2.12062 6.34172 2.36731 6.23109 2.63849C6.12046 2.90967 6.06443 3.20002 6.06623 3.4929V12.1105C5.19494 11.0214 4.34407 9.94587 4.21474 9.76208C4.01789 9.44949 3.74454 9.19229 3.42055 9.01482C3.09657 8.83734 2.73266 8.74545 2.36326 8.74785C2.04993 8.73837 1.73798 8.79322 1.44668 8.909C1.15537 9.02478 0.890885 9.19903 0.669546 9.42101C0.448206 9.64299 0.274712 9.90798 0.159771 10.1996C0.0448296 10.4913 -0.00911833 10.8034 0.00125688 11.1167C0.0625192 12.3419 2.43133 16.6711 4.02415 19.0263C6.4338 22.5931 8.73454 23.1105 8.83664 23.1105H15.9975C16.133 23.109 16.2644 23.0636 16.3719 22.9811C17.5942 21.8547 18.4782 20.4097 18.9245 18.8085C19.6052 16.7051 19.966 13.6829 20 9.57829L19.9932 5.80045ZM17.7605 18.4273C17.3783 19.7228 16.6922 20.9084 15.7593 21.8852H9.01362C8.6937 21.7899 6.9239 21.1364 5.01796 18.3116C3.11202 15.4867 1.26054 11.7225 1.2265 11.0554C1.22102 10.9129 1.24544 10.7708 1.2982 10.6384C1.35096 10.5059 1.43088 10.3859 1.53282 10.2862C1.63323 10.1829 1.75412 10.1016 1.88774 10.0477C2.02137 9.99379 2.16479 9.96837 2.3088 9.97309C2.48862 9.96263 2.66782 10.0023 2.82645 10.0876C2.98509 10.1729 3.11693 10.3006 3.20732 10.4564C3.40472 10.7491 4.81375 12.4985 5.63739 13.5399L7.29147 12.4236V3.4929C7.28003 3.3541 7.2975 3.21444 7.34276 3.08273C7.38803 2.95102 7.46011 2.83013 7.55446 2.72768C7.64881 2.62524 7.76337 2.54347 7.89092 2.48754C8.01847 2.43161 8.15622 2.40274 8.29549 2.40274C8.43476 2.40274 8.57252 2.43161 8.70007 2.48754C8.82761 2.54347 8.94218 2.62524 9.03653 2.72768C9.13088 2.83013 9.20296 2.95102 9.24822 3.08273C9.29349 3.21444 9.31095 3.3541 9.29952 3.4929V11.0758H10.5248V2.22681C10.5537 1.97633 10.6738 1.74524 10.862 1.57749C11.0503 1.40975 11.2936 1.31706 11.5458 1.31706C11.798 1.31706 12.0413 1.40975 12.2296 1.57749C12.4178 1.74524 12.5379 1.97633 12.5668 2.22681V11.1643H13.7921V4.05107C13.7808 3.91686 13.7976 3.78177 13.8412 3.65435C13.8848 3.52694 13.9544 3.40996 14.0456 3.31083C14.1368 3.2117 14.2475 3.13256 14.3708 3.07843C14.4942 3.0243 14.6274 2.99635 14.7621 2.99635C14.8968 2.99635 15.03 3.0243 15.1533 3.07843C15.2766 3.13256 15.3874 3.2117 15.4785 3.31083C15.5697 3.40996 15.6393 3.52694 15.683 3.65435C15.7266 3.78177 15.7433 3.91686 15.7321 4.05107V11.8382H16.9573V5.78003C16.9769 5.55435 17.0804 5.34423 17.2474 5.19114C17.4144 5.03806 17.6327 4.95313 17.8592 4.95313C18.0858 4.95313 18.304 5.03806 18.471 5.19114C18.638 5.34423 18.7415 5.55435 18.7611 5.78003V9.55787C18.7407 13.5808 18.414 16.4465 17.7605 18.4273V18.4273Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.HISTORY:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.9985 9.98168V10.0008C19.9985 15.5233 15.5218 20 9.99931 20C7.7072 20.0037 5.48404 19.2163 3.70514 17.7708L3.72348 17.7858C3.61819 17.7004 3.53203 17.5937 3.47059 17.4728C3.40914 17.3519 3.37378 17.2194 3.36678 17.084C3.35979 16.9486 3.38133 16.8132 3.43 16.6866C3.47867 16.56 3.55339 16.445 3.64931 16.3492L4.10348 15.895C4.27103 15.7258 4.49503 15.6243 4.73269 15.6099C4.97035 15.5954 5.205 15.6691 5.39181 15.8167L5.39014 15.815C6.69967 16.8573 8.32482 17.423 9.99848 17.4192C11.2091 17.4192 12.4013 17.1229 13.4711 16.5563C14.5409 15.9897 15.4558 15.1699 16.1359 14.1684C16.8161 13.167 17.2408 12.0143 17.3732 10.811C17.5055 9.60762 17.3413 8.39018 16.8951 7.26486C16.4488 6.13954 15.7339 5.14052 14.8128 4.35497C13.8917 3.56942 12.7923 3.02119 11.6107 2.75813C10.429 2.49507 9.2009 2.52515 8.03354 2.84577C6.86618 3.16639 5.79501 3.76779 4.91348 4.59751L4.91764 4.59418L6.96431 6.64084C7.05446 6.7311 7.11583 6.84606 7.14065 6.97119C7.16547 7.09632 7.15263 7.22599 7.10375 7.34383C7.05487 7.46166 6.97214 7.56235 6.86604 7.63316C6.75993 7.70398 6.63521 7.74174 6.50764 7.74168H0.645977C0.474912 7.74168 0.310854 7.67372 0.189893 7.55276C0.0689317 7.4318 0.000976563 7.26774 0.000976562 7.09668V1.23501C0.00130623 1.10762 0.0393028 0.983174 0.110186 0.877325C0.181069 0.771476 0.281673 0.688955 0.399341 0.640142C0.517008 0.591329 0.646484 0.578405 0.771478 0.602996C0.896473 0.627588 1.0114 0.688595 1.10181 0.778345L3.09264 2.76918C4.951 0.988517 7.42638 -0.00384586 10.0001 1.12015e-05C15.516 1.12015e-05 19.9893 4.46668 19.9993 9.98001V9.98084L19.9985 9.98168ZM12.7043 13.1575L13.1001 12.6483C13.1784 12.5483 13.2361 12.4338 13.27 12.3114C13.3039 12.189 13.3133 12.0611 13.2976 11.9351C13.282 11.809 13.2416 11.6873 13.1789 11.5769C13.1161 11.4665 13.0321 11.3696 12.9318 11.2917L12.9293 11.29L11.2885 10.0133V5.80668C11.2885 5.27251 10.8551 4.83834 10.3201 4.83834H9.67514C9.14098 4.83834 8.70681 5.27168 8.70681 5.80668V11.2733L11.3443 13.3242C11.5463 13.4823 11.8028 13.5538 12.0574 13.5231C12.3121 13.4923 12.5442 13.3617 12.7026 13.16L12.7043 13.1575Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.INFO:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.58334 19.1667C10.8421 19.1683 12.0887 18.9212 13.2517 18.4394C14.4146 17.9577 15.4708 17.251 16.3597 16.3597C17.251 15.4708 17.9577 14.4146 18.4394 13.2517C18.9212 12.0887 19.1683 10.8421 19.1667 9.58334C19.1683 8.32461 18.9211 7.07796 18.4394 5.91505C17.9577 4.75213 17.2509 3.69587 16.3597 2.80697C15.4708 1.91573 14.4146 1.20894 13.2517 0.727232C12.0887 0.24552 10.8421 -0.00162291 9.58334 8.0196e-06C8.32461 -0.00159665 7.07796 0.245558 5.91505 0.727269C4.75213 1.20898 3.69587 1.91575 2.80697 2.80697C1.91575 3.69587 1.20898 4.75213 0.727269 5.91505C0.245558 7.07796 -0.00159665 8.32461 8.0196e-06 9.58334C-0.00162291 10.8421 0.24552 12.0887 0.727232 13.2517C1.20894 14.4146 1.91573 15.4708 2.80697 16.3597C3.69587 17.2509 4.75213 17.9577 5.91505 18.4394C7.07796 18.9211 8.32461 19.1683 9.58334 19.1667ZM9.58335 3.35425C9.90106 3.35425 10.2058 3.48046 10.4304 3.70511C10.6551 3.92976 10.7813 4.23446 10.7813 4.55216C10.7813 4.86987 10.6551 5.17457 10.4304 5.39922C10.2058 5.62387 9.90106 5.75008 9.58335 5.75008C9.26565 5.75008 8.96095 5.62387 8.7363 5.39922C8.51165 5.17457 8.38544 4.86987 8.38544 4.55216C8.38544 4.23446 8.51165 3.92976 8.7363 3.70511C8.96095 3.48046 9.26565 3.35425 9.58335 3.35425ZM8.86459 6.83341C8.40436 6.83341 8.03126 7.20651 8.03126 7.66675C8.03126 8.12699 8.40436 8.50008 8.86459 8.50008H8.98959V13.5417H8.14584C7.68561 13.5417 7.31251 13.9148 7.31251 14.3751C7.31251 14.8353 7.68561 15.2084 8.14584 15.2084H9.82293H11.5C11.9602 15.2084 12.3333 14.8353 12.3333 14.3751C12.3333 13.9148 11.9602 13.5417 11.5 13.5417H10.6563V7.66675C10.6563 7.20651 10.2832 6.83341 9.82293 6.83341H8.86459Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.LAYERS:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M0.38783 4.62561L7.6672 7.9278C7.8797 8.02436 8.12002 8.02436 8.33252 7.9278L15.6119 4.62561C16.1291 4.39093 16.1291 3.60936 15.6119 3.37468L8.33283 0.0721767C8.22842 0.024455 8.11497 -0.000244141 8.00017 -0.000244141C7.88538 -0.000244141 7.77192 0.024455 7.66752 0.0721767L0.38783 3.37436C-0.129358 3.60905 -0.129358 4.39093 0.38783 4.62561ZM15.6122 7.38436L13.7969 6.56155L8.74564 8.85124C8.50939 8.95843 8.25845 9.0128 8.00002 9.0128C7.74158 9.0128 7.49095 8.95843 7.25439 8.85124L2.20345 6.56155L0.38783 7.38436C-0.129358 7.61874 -0.129358 8.39999 0.38783 8.63436L7.6672 11.9341C7.8797 12.0303 8.12002 12.0303 8.33252 11.9341L15.6122 8.63436C16.1294 8.39999 16.1294 7.61874 15.6122 7.38436V7.38436ZM15.6122 11.3781L13.8038 10.5584L8.74564 12.8512C8.50939 12.9584 8.25845 13.0128 8.00002 13.0128C7.74158 13.0128 7.49095 12.9584 7.25439 12.8512L2.19658 10.5584L0.38783 11.3781C-0.129358 11.6125 -0.129358 12.3937 0.38783 12.6281L7.6672 15.9278C7.8797 16.0241 8.12002 16.0241 8.33252 15.9278L15.6122 12.6281C16.1294 12.3937 16.1294 11.6125 15.6122 11.3781V11.3781Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="none" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.LINK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.LIST:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
          <path
            fillRule="evenodd"
            d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.LOADING:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 80 80"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_633_33)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M44 64C46.1217 64 48.1566 64.8429 49.6569 66.3431C51.1571 67.8434 52 69.8783 52 72C52 74.1217 51.1571 76.1566 49.6569 77.6569C48.1566 79.1571 46.1217 80 44 80C41.8783 80 39.8434 79.1571 38.3431 77.6569C36.8429 76.1566 36 74.1217 36 72C36 69.8783 36.8429 67.8434 38.3431 66.3431C39.8434 64.8429 41.8783 64 44 64ZM18.964 52C21.6162 52 24.1597 53.0536 26.0351 54.9289C27.9104 56.8043 28.964 59.3478 28.964 62C28.964 64.6522 27.9104 67.1957 26.0351 69.0711C24.1597 70.9464 21.6162 72 18.964 72C16.3118 72 13.7683 70.9464 11.8929 69.0711C10.0176 67.1957 8.964 64.6522 8.964 62C8.964 59.3478 10.0176 56.8043 11.8929 54.9289C13.7683 53.0536 16.3118 52 18.964 52ZM65.276 54C67.3977 54 69.4326 54.8429 70.9329 56.3431C72.4331 57.8434 73.276 59.8783 73.276 62C73.276 64.1217 72.4331 66.1566 70.9329 67.6569C69.4326 69.1571 67.3977 70 65.276 70C63.1543 70 61.1194 69.1571 59.6191 67.6569C58.1189 66.1566 57.276 64.1217 57.276 62C57.276 59.8783 58.1189 57.8434 59.6191 56.3431C61.1194 54.8429 63.1543 54 65.276 54ZM74 37.276C75.5913 37.276 77.1174 37.9081 78.2426 39.0334C79.3679 40.1586 80 41.6847 80 43.276C80 44.8673 79.3679 46.3934 78.2426 47.5186C77.1174 48.6439 75.5913 49.276 74 49.276C72.4087 49.276 70.8826 48.6439 69.7574 47.5186C68.6321 46.3934 68 44.8673 68 43.276C68 41.6847 68.6321 40.1586 69.7574 39.0334C70.8826 37.9081 72.4087 37.276 74 37.276ZM10 24C12.6522 24 15.1957 25.0536 17.0711 26.9289C18.9464 28.8043 20 31.3478 20 34C20 36.6522 18.9464 39.1957 17.0711 41.0711C15.1957 42.9464 12.6522 44 10 44C7.34784 44 4.8043 42.9464 2.92893 41.0711C1.05357 39.1957 0 36.6522 0 34C0 31.3478 1.05357 28.8043 2.92893 26.9289C4.8043 25.0536 7.34784 24 10 24ZM71.144 20.828C72.2049 20.828 73.2223 21.2494 73.9724 21.9996C74.7226 22.7497 75.144 23.7671 75.144 24.828C75.144 25.8889 74.7226 26.9063 73.9724 27.6564C73.2223 28.4066 72.2049 28.828 71.144 28.828C70.0831 28.828 69.0657 28.4066 68.3156 27.6564C67.5654 26.9063 67.144 25.8889 67.144 24.828C67.144 23.7671 67.5654 22.7497 68.3156 21.9996C69.0657 21.2494 70.0831 20.828 71.144 20.828ZM32 0C35.1826 0 38.2348 1.26428 40.4853 3.51472C42.7357 5.76515 44 8.8174 44 12C44 15.1826 42.7357 18.2348 40.4853 20.4853C38.2348 22.7357 35.1826 24 32 24C28.8174 24 25.7652 22.7357 23.5147 20.4853C21.2643 18.2348 20 15.1826 20 12C20 8.8174 21.2643 5.76515 23.5147 3.51472C25.7652 1.26428 28.8174 0 32 0V0ZM62 12C62.5304 12 63.0391 12.2107 63.4142 12.5858C63.7893 12.9609 64 13.4696 64 14C64 14.5304 63.7893 15.0391 63.4142 15.4142C63.0391 15.7893 62.5304 16 62 16C61.4696 16 60.9609 15.7893 60.5858 15.4142C60.2107 15.0391 60 14.5304 60 14C60 13.4696 60.2107 12.9609 60.5858 12.5858C60.9609 12.2107 61.4696 12 62 12Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_633_33">
              <rect width="80" height="80" fill="white" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.LOADING_SMALL:
      return (
        <SvgIcon
          title={title}
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.8 12.8C9.22435 12.8 9.63131 12.9686 9.93137 13.2686C10.2314 13.5687 10.4 13.9757 10.4 14.4C10.4 14.8243 10.2314 15.2313 9.93137 15.5314C9.63131 15.8314 9.22435 16 8.8 16C8.37565 16 7.96869 15.8314 7.66863 15.5314C7.36857 15.2313 7.2 14.8243 7.2 14.4C7.2 13.9757 7.36857 13.5687 7.66863 13.2686C7.96869 12.9686 8.37565 12.8 8.8 12.8ZM3.7928 10.4C4.32323 10.4 4.83194 10.6107 5.20701 10.9858C5.58209 11.3609 5.7928 11.8696 5.7928 12.4C5.7928 12.9304 5.58209 13.4391 5.20701 13.8142C4.83194 14.1893 4.32323 14.4 3.7928 14.4C3.26237 14.4 2.75366 14.1893 2.37859 13.8142C2.00351 13.4391 1.7928 12.9304 1.7928 12.4C1.7928 11.8696 2.00351 11.3609 2.37859 10.9858C2.75366 10.6107 3.26237 10.4 3.7928 10.4V10.4ZM13.0552 10.8C13.4795 10.8 13.8865 10.9686 14.1866 11.2686C14.4866 11.5687 14.6552 11.9757 14.6552 12.4C14.6552 12.8243 14.4866 13.2313 14.1866 13.5314C13.8865 13.8314 13.4795 14 13.0552 14C12.6309 14 12.2239 13.8314 11.9238 13.5314C11.6238 13.2313 11.4552 12.8243 11.4552 12.4C11.4552 11.9757 11.6238 11.5687 11.9238 11.2686C12.2239 10.9686 12.6309 10.8 13.0552 10.8V10.8ZM14.8 7.4552C15.1183 7.4552 15.4235 7.58163 15.6485 7.80667C15.8736 8.03172 16 8.33694 16 8.6552C16 8.97346 15.8736 9.27868 15.6485 9.50373C15.4235 9.72877 15.1183 9.8552 14.8 9.8552C14.4817 9.8552 14.1765 9.72877 13.9515 9.50373C13.7264 9.27868 13.6 8.97346 13.6 8.6552C13.6 8.33694 13.7264 8.03172 13.9515 7.80667C14.1765 7.58163 14.4817 7.4552 14.8 7.4552ZM2 4.8C2.53043 4.8 3.03914 5.01071 3.41421 5.38579C3.78929 5.76086 4 6.26957 4 6.8C4 7.33043 3.78929 7.83914 3.41421 8.21421C3.03914 8.58929 2.53043 8.8 2 8.8C1.46957 8.8 0.960859 8.58929 0.585786 8.21421C0.210714 7.83914 0 7.33043 0 6.8C0 6.26957 0.210714 5.76086 0.585786 5.38579C0.960859 5.01071 1.46957 4.8 2 4.8V4.8ZM14.2288 4.1656C14.441 4.1656 14.6445 4.24989 14.7945 4.39991C14.9445 4.54994 15.0288 4.75343 15.0288 4.9656C15.0288 5.17777 14.9445 5.38126 14.7945 5.53129C14.6445 5.68131 14.441 5.7656 14.2288 5.7656C14.0166 5.7656 13.8131 5.68131 13.6631 5.53129C13.5131 5.38126 13.4288 5.17777 13.4288 4.9656C13.4288 4.75343 13.5131 4.54994 13.6631 4.39991C13.8131 4.24989 14.0166 4.1656 14.2288 4.1656ZM6.4 0C7.03652 0 7.64697 0.252856 8.09706 0.702944C8.54714 1.15303 8.8 1.76348 8.8 2.4C8.8 3.03652 8.54714 3.64697 8.09706 4.09706C7.64697 4.54714 7.03652 4.8 6.4 4.8C5.76348 4.8 5.15303 4.54714 4.70294 4.09706C4.25286 3.64697 4 3.03652 4 2.4C4 1.76348 4.25286 1.15303 4.70294 0.702944C5.15303 0.252856 5.76348 0 6.4 0V0ZM12.4 2.4C12.5061 2.4 12.6078 2.44214 12.6828 2.51716C12.7579 2.59217 12.8 2.69391 12.8 2.8C12.8 2.90609 12.7579 3.00783 12.6828 3.08284C12.6078 3.15786 12.5061 3.2 12.4 3.2C12.2939 3.2 12.1922 3.15786 12.1172 3.08284C12.0421 3.00783 12 2.90609 12 2.8C12 2.69391 12.0421 2.59217 12.1172 2.51716C12.1922 2.44214 12.2939 2.4 12.4 2.4V2.4Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="none" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.LOCK_CLOSED:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.LOCK_OPEN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z" />
        </SvgIcon>
      );
    case iconTypes.MAP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M12 1.586l-4 4v12.828l4-4V1.586zM3.707 3.293A1 1 0 002 4v10a1 1 0 00.293.707L6 18.414V5.586L3.707 3.293zM17.707 5.293L14 1.586v12.828l2.293 2.293A1 1 0 0018 16V6a1 1 0 00-.293-.707z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.MAP_LOCATION:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.MENU:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.MEDIA_GOOGLE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M24.7569 10.0519H23.75V10H12.5V15H19.5644C18.5338 17.9106 15.7644 20 12.5 20C8.35812 20 5 16.6419 5 12.5C5 8.35812 8.35812 5 12.5 5C14.4119 5 16.1513 5.72125 17.4756 6.89937L21.0112 3.36375C18.7787 1.28312 15.7925 0 12.5 0C5.59688 0 0 5.59688 0 12.5C0 19.4031 5.59688 25 12.5 25C19.4031 25 25 19.4031 25 12.5C25 11.6619 24.9137 10.8438 24.7569 10.0519Z"
            fill="#FFC107"
          />
          <path
            d="M1.44128 6.68188L5.54816 9.69375C6.65941 6.9425 9.35066 5 12.5 5C14.4119 5 16.1513 5.72125 17.4757 6.89937L21.0113 3.36375C18.7788 1.28312 15.7925 0 12.5 0C7.69878 0 3.53503 2.71062 1.44128 6.68188Z"
            fill="#FF3D00"
          />
          <path
            d="M12.5 25C15.7287 25 18.6625 23.7644 20.8806 21.755L17.0118 18.4813C15.7147 19.4677 14.1296 20.0013 12.5 20C9.2487 20 6.48808 17.9269 5.44808 15.0338L1.37183 18.1744C3.44058 22.2225 7.64183 25 12.5 25Z"
            fill="#4CAF50"
          />
          <path
            d="M24.7569 10.0519H23.75V10H12.5V15H19.5644C19.0714 16.3853 18.1833 17.5957 17.01 18.4819L17.0119 18.4806L20.8806 21.7544C20.6069 22.0031 25 18.75 25 12.5C25 11.6619 24.9137 10.8438 24.7569 10.0519Z"
            fill="#1976D2"
          />
        </SvgIcon>
      );
    case iconTypes.MEDIA_FACEBOOK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 25 25"
          fill="none"
        >
          <g clipPath="url(#clip0_97_23)">
            <path
              d="M25 12.5C25 5.59648 19.4035 0 12.5 0C5.59648 0 0 5.59639 0 12.5C0 18.7391 4.57109 23.9104 10.5469 24.8481V16.1133H7.37305V12.5H10.5469V9.74609C10.5469 6.61328 12.4131 4.88281 15.2683 4.88281C16.6359 4.88281 18.0664 5.12695 18.0664 5.12695V8.20312H16.4902C14.9373 8.20312 14.4531 9.1667 14.4531 10.1553V12.5H17.9199L17.3657 16.1133H14.4531V24.8481C20.4289 23.9104 25 18.7392 25 12.5Z"
              fill="#1877F2"
            />
            <path
              d="M17.3657 16.1133L17.9199 12.5H14.4531V10.1553C14.4531 9.1666 14.9374 8.20312 16.4902 8.20312H18.0664V5.12695C18.0664 5.12695 16.6359 4.88281 15.2683 4.88281C12.4131 4.88281 10.5469 6.61328 10.5469 9.74609V12.5H7.37305V16.1133H10.5469V24.8481C11.193 24.9494 11.846 25.0002 12.5 25C13.154 25.0002 13.807 24.9494 14.4531 24.8481V16.1133H17.3657Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_97_23">
              <rect width="25" height="25" fill="white" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.MEDIA_APPLE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path
            d="M19.5139 24C18.1528 25.3194 16.6667 25.1111 15.2361 24.4861C13.7222 23.8472 12.3333 23.8194 10.7361 24.4861C8.73611 25.3472 7.68056 25.0972 6.48611 24C-0.291667 17.0139 0.708334 6.375 8.40278 5.98611C10.2778 6.08333 11.5833 7.01389 12.6806 7.09722C14.3194 6.76389 15.8889 5.80556 17.6389 5.93056C19.7361 6.09722 21.3194 6.93055 22.3611 8.43055C18.0278 11.0278 19.0556 16.7361 23.0278 18.3333C22.2361 20.4167 21.2083 22.4861 19.5 24.0139L19.5139 24ZM12.5417 5.90278C12.3333 2.80556 14.8472 0.25 17.7361 0C18.1389 3.58333 14.4861 6.25 12.5417 5.90278Z"
            fill="#CECCCD"
          />
        </SvgIcon>
      );
    case iconTypes.MEDIA_MICROSOFT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path d="M0 1C0 0.447715 0.447715 0 1 0H11.875V11.875H0V1Z" fill="#F44336" />
          <path d="M0 13.125H11.875V25H1C0.447715 25 0 24.5523 0 24V13.125Z" fill="#2196F3" />
          <path d="M13.125 0H24C24.5523 0 25 0.447715 25 1V11.875H13.125V0Z" fill="#4CAF50" />
          <path
            d="M13.125 13.125H25V24C25 24.5523 24.5523 25 24 25H13.125V13.125Z"
            fill="#FFC107"
          />
        </SvgIcon>
      );
    case iconTypes.MEDIA_RECOVER_SENT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 152 123"
          fill="none"
        >
          <path
            d="M147.974 30.7167L7.92816 0.506487L6.10814 0.114798C5.1813 -0.086503 4.21647 -0.0221255 3.32459 0.300529C2.43272 0.623184 1.65001 1.19099 1.06649 1.9387C0.482973 2.6864 0.122319 3.58362 0.0260332 4.52716C-0.070253 5.47071 0.101746 6.42228 0.522208 7.27243L56.1263 120.191C56.4861 120.917 57.015 121.545 57.6684 122.023C58.3219 122.502 59.0806 122.816 59.8809 122.94C60.6837 123.065 61.5048 122.993 62.2734 122.729C63.0419 122.466 63.7347 122.019 64.292 121.428L102.913 80.7049C103.188 80.408 103.521 80.171 103.892 80.0091C104.263 79.8472 104.663 79.7638 105.068 79.7641C105.618 79.7563 106.159 79.8982 106.635 80.1747C107.11 80.4511 107.501 80.8517 107.767 81.3334L115.678 95.9656C116.183 96.9412 116.999 97.7198 117.998 98.1775C118.997 98.6352 120.12 98.7455 121.189 98.4911L121.228 98.4824C122.31 98.2533 123.283 97.6671 123.991 96.818C124.7 95.969 125.102 94.9064 125.133 93.8012L126.718 60.025C126.737 59.6036 126.842 59.1905 127.027 58.8114C127.226 58.4363 127.496 58.1033 127.821 57.831L150.102 39.5411C150.835 38.94 151.383 38.1446 151.684 37.2463C151.985 36.3479 152.027 35.3829 151.805 34.4618C151.583 33.5407 151.106 32.7009 150.428 32.0385C149.751 31.3761 148.9 30.918 147.974 30.7167ZM148.83 37.9863L126.549 56.2763C126.259 56.5101 125.996 56.7759 125.765 57.0686L7.67505 3.51286C7.57089 3.46441 7.46225 3.42631 7.35065 3.39906C6.89516 3.28167 6.41296 3.32714 5.98745 3.52762C5.56194 3.7281 5.21986 4.07099 5.0204 4.49698C4.82093 4.92296 4.77661 5.40525 4.8951 5.86045C5.01359 6.31566 5.28745 6.71517 5.66929 6.98984L102.765 78.3134C102.273 78.5696 101.828 78.9088 101.45 79.3162L62.8295 120.039C62.4944 120.391 62.0791 120.658 61.6189 120.816C61.1587 120.974 60.6673 121.018 60.1863 120.945C59.7053 120.872 59.2489 120.684 58.8561 120.397C58.4632 120.11 58.1455 119.733 57.9297 119.297L2.3257 6.37824C2.07712 5.86804 1.97683 5.29827 2.03628 4.73386C2.09573 4.16945 2.31251 3.63306 2.66193 3.18585C3.01135 2.73864 3.47937 2.39858 4.01265 2.20438C4.54593 2.01019 5.12303 1.96968 5.67821 2.08748L7.54145 2.49011L147.544 32.6895C148.1 32.8099 148.611 33.0843 149.018 33.4815C149.425 33.8786 149.712 34.3824 149.846 34.9351C149.98 35.4878 149.956 36.0671 149.777 36.6067C149.597 37.1464 149.269 37.6245 148.83 37.9863Z"
            fill="#7AC0A6"
          />
          <path
            d="M147.974 30.7167L7.92816 0.506487L6.10814 0.114798C5.1813 -0.086503 4.21647 -0.0221255 3.32459 0.300529C2.43272 0.623184 1.65001 1.19099 1.06649 1.9387C0.482973 2.6864 0.122319 3.58362 0.0260332 4.52716C-0.070253 5.47071 0.101746 6.42228 0.522208 7.27243L56.1263 120.191C56.4861 120.917 57.015 121.545 57.6684 122.023C58.3219 122.502 59.0806 122.816 59.8809 122.94C60.6837 123.065 61.5048 122.993 62.2734 122.729C63.0419 122.466 63.7347 122.019 64.292 121.428L102.913 80.7049C103.188 80.4079 103.521 80.171 103.892 80.0091C104.263 79.8472 104.663 79.7638 105.068 79.7641C105.618 79.7563 106.159 79.8982 106.635 80.1747C107.11 80.4511 107.501 80.8517 107.767 81.3334L115.678 95.9656C116.183 96.9412 116.999 97.7198 117.998 98.1775C118.997 98.6352 120.12 98.7455 121.189 98.4911L121.228 98.4824C122.31 98.2533 123.283 97.667 123.991 96.818C124.7 95.969 125.102 94.9064 125.133 93.8012L126.718 60.025C126.737 59.6035 126.842 59.1905 127.027 58.8114C127.226 58.4363 127.496 58.1033 127.821 57.831L150.102 39.5411C150.835 38.94 151.383 38.1446 151.684 37.2463C151.985 36.3479 152.027 35.3829 151.805 34.4618C151.583 33.5407 151.106 32.7009 150.428 32.0385C149.751 31.3761 148.9 30.918 147.974 30.7167ZM148.83 37.9863L126.549 56.2763C126.259 56.5101 125.996 56.7759 125.765 57.0686C125.556 57.329 125.377 57.6109 125.228 57.9095C125.073 58.2149 124.95 58.536 124.863 58.8672L124.865 58.8771C124.773 59.2222 124.72 59.5765 124.707 59.9335L123.122 93.7096C123.109 94.3738 122.87 95.0136 122.445 95.5239C122.02 96.0342 121.433 96.3847 120.783 96.5176L120.763 96.5219C120.122 96.6812 119.445 96.6192 118.844 96.346C118.242 96.0728 117.75 95.6043 117.448 95.0166L109.535 80.3746C109.128 79.6215 108.534 78.9851 107.812 78.5257C107.089 78.0663 106.261 77.7992 105.406 77.7498L105.396 77.7519C105.281 77.7465 105.166 77.7409 105.054 77.7451C104.256 77.7454 103.471 77.9405 102.765 78.3134C102.273 78.5696 101.828 78.9088 101.45 79.3162L62.8296 120.039C62.4944 120.391 62.0791 120.658 61.6189 120.816C61.1588 120.974 60.6673 121.018 60.1863 120.945C59.7053 120.872 59.249 120.684 58.8561 120.397C58.4633 120.11 58.1455 119.733 57.9298 119.297L2.3257 6.37824C2.07712 5.86804 1.97683 5.29827 2.03628 4.73386C2.09573 4.16945 2.31251 3.63306 2.66193 3.18585C3.01135 2.73864 3.47937 2.39858 4.01265 2.20438C4.54593 2.01019 5.12303 1.96968 5.67821 2.08748L7.54145 2.49011L147.544 32.6895C148.1 32.8099 148.611 33.0843 149.018 33.4815C149.425 33.8786 149.712 34.3824 149.846 34.9351C149.98 35.4878 149.956 36.0671 149.777 36.6067C149.597 37.1464 149.269 37.6245 148.83 37.9863Z"
            fill="#3F3D56"
          />
          <path
            d="M126.211 57.2693L125.379 59.1041L124.865 58.8774L124.863 58.8675L6.86646 5.36339L105.396 77.7522L105.405 77.75L105.666 77.9502L104.478 79.5748L102.765 78.3137L5.66883 6.99007C5.28698 6.71539 5.01313 6.31591 4.89464 5.86071C4.77615 5.4055 4.82047 4.92319 5.01994 4.4972C5.2194 4.07121 5.56148 3.72833 5.98699 3.52784C6.4125 3.32736 6.8947 3.28189 7.35018 3.39929C7.46178 3.42653 7.57043 3.46466 7.67458 3.51312L125.764 57.0689L126.211 57.2693Z"
            fill="#3F3D56"
          />
        </SvgIcon>
      );
    case iconTypes.MEDIA_USER_NOT_ACTIVATED:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 174 133"
          fill="none"
        >
          <path
            d="M146.206 132.421L34.6686 132.46C29.0652 132.462 24.0459 129.566 21.2425 124.714C19.8407 122.288 19.1396 119.627 19.1387 116.965C19.1377 114.303 19.8373 111.641 21.2372 109.214L76.9705 7.75463C79.7708 2.90066 84.7881 0.00193854 90.3915 9.71885e-07C95.9949 -0.0019366 101.014 2.89331 103.818 7.74534L159.629 109.179C161.027 111.598 161.726 114.257 161.726 116.917C161.726 119.577 161.027 122.239 159.627 124.666C156.827 129.52 151.809 132.419 146.206 132.421ZM20.5407 116.963C20.5405 119.386 32.8483 114.165 34.1234 116.372C36.6739 120.786 29.5702 131.062 34.6681 131.061C34.6681 131.061 155.868 128.383 158.415 123.967C159.689 121.759 160.325 119.337 160.324 116.916C160.323 114.494 159.685 112.073 158.41 109.866L102.599 8.43261C100.056 4.03133 95.4899 1.3972 90.392 1.39897C85.2965 1.40073 20.5409 114.54 20.5407 116.963Z"
            fill="#666666"
          />
          <path
            d="M122.938 110.046C151.139 110.046 174 87.1843 174 58.9834C174 30.7825 151.139 7.92114 122.938 7.92114C94.7368 7.92114 71.8755 30.7825 71.8755 58.9834C71.8755 87.1843 94.7368 110.046 122.938 110.046Z"
            fill="#E6566A"
          />
          <path
            d="M122.946 90.2852C125.535 90.2852 127.635 88.1861 127.635 85.5968C127.635 83.0075 125.535 80.9084 122.946 80.9084C120.357 80.9084 118.258 83.0075 118.258 85.5968C118.258 88.1861 120.357 90.2852 122.946 90.2852Z"
            fill="white"
          />
          <path
            d="M122.927 27.6815C122.496 30.5432 123.268 31.142 123.272 43.4794C123.276 55.8167 125.836 72.358 122.942 72.359C120.048 72.36 118.99 38.2223 108.941 35.201C97.1259 31.6487 124.321 18.4175 122.927 27.6815Z"
            fill="white"
          />
          <path
            d="M54.4052 85.0536L49.7919 94.8011C55.3691 90.8018 64.0803 87.3544 71.0125 85.508C64.5535 82.388 56.65 77.3577 51.9282 72.3773L54.5816 82.6768C23.4729 76.3405 1.13316 52.4755 1.1237 25.1378L0 24.7512C0.0098767 53.3061 22.0405 78.5842 54.4052 85.0536Z"
            fill="#666666"
          />
        </SvgIcon>
      );
    case iconTypes.MEDIA_USER_ACTIVATION_EMAIL:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 150 135"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3_281)">
            <path
              d="M148.684 51.4934C148.631 51.4934 148.578 51.4769 148.534 51.4462L75.7554 0.761075C75.5339 0.607549 75.2707 0.525501 75.0012 0.525961C74.7317 0.52642 74.4688 0.609364 74.2479 0.763645L1.99345 51.4457C1.9363 51.4858 1.86557 51.5015 1.79682 51.4894C1.72806 51.4774 1.66691 51.4385 1.62683 51.3813C1.58674 51.3242 1.571 51.2535 1.58306 51.1847C1.59513 51.116 1.63402 51.0548 1.69117 51.0147L73.9457 0.332672C74.255 0.116712 74.6231 0.000622532 75.0004 2.49673e-06C75.3777 -0.000617538 75.7461 0.11426 76.0562 0.329203L148.835 51.0142C148.881 51.0462 148.915 51.0921 148.933 51.1451C148.952 51.1982 148.952 51.2556 148.935 51.3091C148.919 51.3625 148.885 51.4092 148.84 51.4424C148.795 51.4755 148.74 51.4934 148.684 51.4934Z"
              fill="#3F3D56"
            />
            <path
              d="M6.12183 53.2902L75.0723 2.18939L144.546 56.9262L78.625 96.0052L42.8355 87.8473L6.12183 53.2902Z"
              fill="#E6E6E6"
            />
            <path
              d="M45.8566 120.143H11.7934C11.5843 120.143 11.3771 120.102 11.1838 120.022C10.9905 119.942 10.8148 119.825 10.6668 119.677C10.5188 119.53 10.4014 119.354 10.3213 119.161C10.2412 118.968 10.2 118.761 10.2 118.551C10.2 118.342 10.2412 118.135 10.3213 117.942C10.4014 117.749 10.5188 117.573 10.6668 117.425C10.8148 117.278 10.9905 117.16 11.1838 117.081C11.3771 117.001 11.5843 116.96 11.7934 116.96H45.8566C46.0658 116.96 46.273 117.001 46.4663 117.081C46.6596 117.16 46.8353 117.278 46.9833 117.425C47.1313 117.573 47.2487 117.749 47.3288 117.942C47.4089 118.135 47.4501 118.342 47.4501 118.551C47.4501 118.761 47.4089 118.968 47.3288 119.161C47.2487 119.354 47.1313 119.53 46.9833 119.677C46.8353 119.825 46.6596 119.942 46.4663 120.022C46.273 120.102 46.0658 120.143 45.8566 120.143Z"
              fill="#7AC0A6"
            />
            <path
              d="M24.0145 113.3H11.7934C11.5843 113.301 11.3771 113.26 11.1838 113.18C10.9905 113.1 10.8148 112.983 10.6668 112.835C10.5188 112.687 10.4014 112.512 10.3213 112.319C10.2412 112.125 10.2 111.918 10.2 111.709C10.2 111.5 10.2412 111.293 10.3213 111.1C10.4014 110.906 10.5188 110.731 10.6668 110.583C10.8148 110.435 10.9905 110.318 11.1838 110.238C11.3771 110.158 11.5843 110.117 11.7934 110.118H24.0145C24.2237 110.117 24.4309 110.158 24.6242 110.238C24.8175 110.318 24.9932 110.435 25.1412 110.583C25.2892 110.731 25.4066 110.906 25.4867 111.1C25.5668 111.293 25.608 111.5 25.608 111.709C25.608 111.918 25.5668 112.125 25.4867 112.319C25.4066 112.512 25.2892 112.687 25.1412 112.835C24.9932 112.983 24.8175 113.1 24.6242 113.18C24.4309 113.26 24.2237 113.301 24.0145 113.3Z"
              fill="#55AEA2"
            />
            <path
              d="M76.0419 81.7523C75.783 81.7526 75.5265 81.7023 75.2868 81.6044L32.7629 63.96V8.72995C32.7635 8.24157 32.9578 7.77336 33.3031 7.42802C33.6484 7.08268 34.1167 6.88842 34.605 6.88785H116.184C116.672 6.88842 117.141 7.08268 117.486 7.42802C117.831 7.77336 118.026 8.24157 118.026 8.72995V63.9985L117.946 64.0327L76.8198 81.5958C76.5735 81.6992 76.309 81.7525 76.0419 81.7523Z"
              fill="#FAFAFA"
            />
            <path
              d="M76.0421 81.8839C75.766 81.8842 75.4925 81.8307 75.237 81.7264L32.6316 64.048V8.73015C32.6322 8.20688 32.8403 7.70521 33.2103 7.3352C33.5803 6.96519 34.082 6.75706 34.6053 6.75647H116.184C116.707 6.75706 117.209 6.96519 117.579 7.3352C117.949 7.70521 118.157 8.20688 118.158 8.73015V64.0856L76.8717 81.7169C76.6091 81.8274 76.327 81.8842 76.0421 81.8839ZM33.1579 63.6965L75.4377 81.2398C75.832 81.3998 76.2737 81.3972 76.6661 81.2325L117.632 63.7381V8.73015C117.631 8.34643 117.479 7.97855 117.207 7.70721C116.936 7.43588 116.568 7.28324 116.184 7.28279H34.6053C34.2216 7.28324 33.8537 7.43588 33.5823 7.70721C33.311 7.97855 33.1584 8.34643 33.1579 8.73015L33.1579 63.6965Z"
              fill="#3F3D56"
            />
            <path
              d="M148.158 50.9669H148.105L117.895 63.8669L76.5606 81.5169C76.3991 81.5848 76.2257 81.6202 76.0505 81.6211C75.8753 81.622 75.7016 81.5884 75.5394 81.5221L32.8947 63.83L1.94207 50.9879L1.89479 50.9669H1.84211C1.35371 50.9674 0.885481 51.1617 0.540137 51.507C0.194793 51.8523 0.000541908 52.3206 0 52.809V132.809C0.000542603 133.297 0.194793 133.766 0.540137 134.111C0.885481 134.456 1.35372 134.651 1.84211 134.651H148.158C148.646 134.651 149.115 134.456 149.46 134.111C149.805 133.766 149.999 133.297 150 132.809V52.809C149.999 52.3206 149.805 51.8523 149.46 51.507C149.115 51.1617 148.646 50.9674 148.158 50.9669ZM149.474 132.809C149.474 133.158 149.335 133.492 149.088 133.739C148.841 133.986 148.507 134.125 148.158 134.125H1.84211C1.49318 134.125 1.15859 133.986 0.911857 133.739C0.665129 133.492 0.526455 133.158 0.526316 132.809V52.809C0.526793 52.4687 0.658779 52.1418 0.894679 51.8966C1.13058 51.6514 1.45213 51.5068 1.79212 51.4932L32.8947 64.3984L75.3369 82.009C75.7963 82.1959 76.3111 82.1931 76.7685 82.0011L117.895 64.4379L148.211 51.4932C148.55 51.5078 148.871 51.6528 149.106 51.8978C149.341 52.1429 149.473 52.4692 149.474 52.809V132.809Z"
              fill="#3F3D56"
            />
            <path
              d="M75.6173 66.0917C74.0475 66.0946 72.5192 65.587 71.2631 64.6453L71.1853 64.5869L54.7876 52.0323C54.0282 51.4504 53.3909 50.7247 52.9119 49.8965C52.433 49.0683 52.1219 48.1539 51.9963 47.2055C51.8708 46.2571 51.9333 45.2932 52.1803 44.3689C52.4272 43.4447 52.8538 42.5781 53.4357 41.8187C54.0175 41.0593 54.7433 40.4219 55.5714 39.943C56.3996 39.4641 57.314 39.1529 58.2624 39.0274C59.2109 38.9018 60.1747 38.9643 61.099 39.2113C62.0233 39.4582 62.8898 39.8848 63.6492 40.4667L74.2704 48.6108L99.3698 15.8775C99.952 15.1183 100.678 14.4812 101.506 14.0025C102.335 13.5239 103.249 13.2131 104.198 13.0879C105.146 12.9627 106.11 13.0255 107.034 13.2728C107.958 13.5201 108.825 13.947 109.584 14.5292L109.428 14.7411L109.588 14.5323C111.119 15.7093 112.121 17.4457 112.374 19.3605C112.627 21.2754 112.11 23.2123 110.936 24.7463L81.4132 63.2486C80.7304 64.1358 79.8524 64.8538 78.8472 65.3469C77.8421 65.8399 76.7369 66.0948 75.6173 66.0917Z"
              fill="#7AC0A6"
            />
          </g>
          <defs>
            <clipPath id="clip0_3_281">
              <rect width="150" height="134.651" fill="white" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.MEDIA_PASS_RECOVERY:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 152 123"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M147.974 30.7167L7.92816 0.506487L6.10814 0.114798C5.1813 -0.086503 4.21647 -0.0221255 3.32459 0.300529C2.43272 0.623184 1.65001 1.19099 1.06649 1.9387C0.482973 2.6864 0.122319 3.58362 0.0260332 4.52716C-0.070253 5.47071 0.101746 6.42228 0.522208 7.27243L56.1263 120.191C56.4861 120.917 57.015 121.545 57.6684 122.023C58.3219 122.502 59.0806 122.816 59.8809 122.94C60.6837 123.065 61.5048 122.993 62.2734 122.729C63.0419 122.466 63.7347 122.019 64.292 121.428L102.913 80.7049C103.188 80.408 103.521 80.171 103.892 80.0091C104.263 79.8472 104.663 79.7638 105.068 79.7641C105.618 79.7563 106.159 79.8982 106.635 80.1747C107.11 80.4511 107.501 80.8517 107.767 81.3334L115.678 95.9656C116.183 96.9412 116.999 97.7198 117.998 98.1775C118.997 98.6352 120.12 98.7455 121.189 98.4911L121.228 98.4824C122.31 98.2533 123.283 97.6671 123.991 96.818C124.7 95.969 125.102 94.9064 125.133 93.8012L126.718 60.025C126.737 59.6036 126.842 59.1905 127.027 58.8114C127.226 58.4363 127.496 58.1033 127.821 57.831L150.102 39.5411C150.835 38.94 151.383 38.1446 151.684 37.2463C151.985 36.3479 152.027 35.3829 151.805 34.4618C151.583 33.5407 151.106 32.7009 150.428 32.0385C149.751 31.3761 148.9 30.918 147.974 30.7167ZM148.83 37.9863L126.549 56.2763C126.259 56.5101 125.996 56.7759 125.765 57.0686L7.67505 3.51286C7.57089 3.46441 7.46225 3.42631 7.35065 3.39906C6.89516 3.28167 6.41296 3.32714 5.98745 3.52762C5.56194 3.7281 5.21986 4.07099 5.0204 4.49698C4.82093 4.92296 4.77661 5.40525 4.8951 5.86045C5.01359 6.31566 5.28745 6.71517 5.66929 6.98984L102.765 78.3134C102.273 78.5696 101.828 78.9088 101.45 79.3162L62.8295 120.039C62.4944 120.391 62.0791 120.658 61.6189 120.816C61.1587 120.974 60.6673 121.018 60.1863 120.945C59.7053 120.872 59.2489 120.684 58.8561 120.397C58.4632 120.11 58.1455 119.733 57.9297 119.297L2.3257 6.37824C2.07712 5.86804 1.97683 5.29827 2.03628 4.73386C2.09573 4.16945 2.31251 3.63306 2.66193 3.18585C3.01135 2.73864 3.47937 2.39858 4.01265 2.20438C4.54593 2.01019 5.12303 1.96968 5.67821 2.08748L7.54145 2.49011L147.544 32.6895C148.1 32.8099 148.611 33.0843 149.018 33.4815C149.425 33.8786 149.712 34.3824 149.846 34.9351C149.98 35.4878 149.956 36.0671 149.777 36.6067C149.597 37.1464 149.269 37.6245 148.83 37.9863Z"
            fill="#7AC0A6"
          />
          <path
            d="M147.974 30.7167L7.92816 0.506487L6.10814 0.114798C5.1813 -0.086503 4.21647 -0.0221255 3.32459 0.300529C2.43272 0.623184 1.65001 1.19099 1.06649 1.9387C0.482973 2.6864 0.122319 3.58362 0.0260332 4.52716C-0.070253 5.47071 0.101746 6.42228 0.522208 7.27243L56.1263 120.191C56.4861 120.917 57.015 121.545 57.6684 122.023C58.3219 122.502 59.0806 122.816 59.8809 122.94C60.6837 123.065 61.5048 122.993 62.2734 122.729C63.0419 122.466 63.7347 122.019 64.292 121.428L102.913 80.7049C103.188 80.4079 103.521 80.171 103.892 80.0091C104.263 79.8472 104.663 79.7638 105.068 79.7641C105.618 79.7563 106.159 79.8982 106.635 80.1747C107.11 80.4511 107.501 80.8517 107.767 81.3334L115.678 95.9656C116.183 96.9412 116.999 97.7198 117.998 98.1775C118.997 98.6352 120.12 98.7455 121.189 98.4911L121.228 98.4824C122.31 98.2533 123.283 97.667 123.991 96.818C124.7 95.969 125.102 94.9064 125.133 93.8012L126.718 60.025C126.737 59.6035 126.842 59.1905 127.027 58.8114C127.226 58.4363 127.496 58.1033 127.821 57.831L150.102 39.5411C150.835 38.94 151.383 38.1446 151.684 37.2463C151.985 36.3479 152.027 35.3829 151.805 34.4618C151.583 33.5407 151.106 32.7009 150.428 32.0385C149.751 31.3761 148.9 30.918 147.974 30.7167ZM148.83 37.9863L126.549 56.2763C126.259 56.5101 125.996 56.7759 125.765 57.0686C125.556 57.329 125.377 57.6109 125.228 57.9095C125.073 58.2149 124.95 58.536 124.863 58.8672L124.865 58.8771C124.773 59.2222 124.72 59.5765 124.707 59.9335L123.122 93.7096C123.109 94.3738 122.87 95.0136 122.445 95.5239C122.02 96.0342 121.433 96.3847 120.783 96.5176L120.763 96.5219C120.122 96.6812 119.445 96.6192 118.844 96.346C118.242 96.0728 117.75 95.6043 117.448 95.0166L109.535 80.3746C109.128 79.6215 108.534 78.9851 107.812 78.5257C107.089 78.0663 106.261 77.7992 105.406 77.7498L105.396 77.7519C105.281 77.7465 105.166 77.7409 105.054 77.7451C104.256 77.7454 103.471 77.9405 102.765 78.3134C102.273 78.5696 101.828 78.9088 101.45 79.3162L62.8296 120.039C62.4944 120.391 62.0791 120.658 61.6189 120.816C61.1588 120.974 60.6673 121.018 60.1863 120.945C59.7053 120.872 59.249 120.684 58.8561 120.397C58.4633 120.11 58.1455 119.733 57.9298 119.297L2.3257 6.37824C2.07712 5.86804 1.97683 5.29827 2.03628 4.73386C2.09573 4.16945 2.31251 3.63306 2.66193 3.18585C3.01135 2.73864 3.47937 2.39858 4.01265 2.20438C4.54593 2.01019 5.12303 1.96968 5.67821 2.08748L7.54145 2.49011L147.544 32.6895C148.1 32.8099 148.611 33.0843 149.018 33.4815C149.425 33.8786 149.712 34.3824 149.846 34.9351C149.98 35.4878 149.956 36.0671 149.777 36.6067C149.597 37.1464 149.269 37.6245 148.83 37.9863Z"
            fill="#3F3D56"
          />
          <path
            d="M126.211 57.2693L125.379 59.1041L124.865 58.8774L124.863 58.8675L6.86646 5.36339L105.396 77.7522L105.405 77.75L105.666 77.9502L104.478 79.5748L102.765 78.3137L5.66883 6.99007C5.28698 6.71539 5.01313 6.31591 4.89464 5.86071C4.77615 5.4055 4.82047 4.92319 5.01994 4.4972C5.2194 4.07121 5.56148 3.72833 5.98699 3.52784C6.4125 3.32736 6.8947 3.28189 7.35018 3.39929C7.46178 3.42653 7.57043 3.46466 7.67458 3.51312L125.764 57.0689L126.211 57.2693Z"
            fill="#3F3D56"
          />
        </SvgIcon>
      );
    case iconTypes.MEDIA_PASS_RESET_OK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 135 137"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M54.4404 136.56C84.5069 136.56 108.881 112.187 108.881 82.12C108.881 52.0535 84.5069 27.6797 54.4404 27.6797C24.3738 27.6797 0 52.0535 0 82.12C0 112.187 24.3738 136.56 54.4404 136.56Z"
            fill="#7AC0A6"
          />
          <path
            d="M72.5872 130.511C61.2218 130.511 50.1115 127.141 40.6614 120.827C31.2114 114.512 23.846 105.538 19.4967 95.0372C15.1473 84.5369 14.0092 72.9825 16.2265 61.8355C18.4438 50.6884 23.9169 40.4492 31.9535 32.4126C39.9901 24.376 50.2293 18.9031 61.3764 16.6858C72.5234 14.4685 84.0777 15.6064 94.578 19.9557C105.078 24.3051 114.053 31.6705 120.367 41.1205C126.682 50.5706 130.052 61.6809 130.052 73.0463C130.035 88.2816 123.975 102.888 113.202 113.661C102.429 124.434 87.8225 130.494 72.5872 130.511ZM72.5872 21.6304C62.4181 21.6304 52.4774 24.646 44.0221 30.2957C35.5668 35.9453 28.9766 43.9753 25.0851 53.3703C21.1936 62.7654 20.1753 73.1033 22.1592 83.077C24.1431 93.0508 29.04 102.212 36.2306 109.403C43.4213 116.593 52.5827 121.49 62.5564 123.474C72.5301 125.458 82.8682 124.44 92.2632 120.549C101.658 116.657 109.688 110.067 115.338 101.611C120.988 93.1562 124.003 83.2154 124.003 73.0463C123.988 59.4146 118.566 46.3457 108.927 36.7066C99.2879 27.0675 86.2189 21.6456 72.5872 21.6304Z"
            fill="#666666"
          />
          <path
            d="M73.3946 94.5084L44.1147 65.2255L52.6679 56.6725L71.7795 75.7811L125.107 0L135 6.96528L73.3946 94.5084Z"
            fill="#666666"
          />
        </SvgIcon>
      );
    case iconTypes.MINUS_CIRCLE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.MOVE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.71 9.31L16.71 6.31001C16.5217 6.1217 16.2663 6.01591 16 6.01591C15.7337 6.01591 15.4783 6.1217 15.29 6.31001C15.1017 6.49831 14.9959 6.7537 14.9959 7.02001C14.9959 7.28631 15.1017 7.5417 15.29 7.73L16.58 9H11V3.41001L12.29 4.71001C12.3834 4.80269 12.4943 4.87601 12.6161 4.92578C12.7379 4.97554 12.8684 5.00077 13 5.00001C13.1316 5.00077 13.2621 4.97554 13.3839 4.92578C13.5057 4.87601 13.6166 4.80269 13.71 4.71001C13.8037 4.61705 13.8781 4.50644 13.9289 4.38459C13.9797 4.26273 14.0058 4.13202 14.0058 4.00001C14.0058 3.868 13.9797 3.73729 13.9289 3.61543C13.8781 3.49357 13.8037 3.38297 13.71 3.29001L10.71 0.290016C10.6166 0.197335 10.5057 0.12401 10.3839 0.0742453C10.2621 0.0244808 10.1316 -0.000744178 10 1.67143e-05C9.73766 0.00112133 9.48626 0.105272 9.3 0.290016L6.30001 3.29001C6.20677 3.38259 6.13268 3.49263 6.08197 3.61385C6.03125 3.73506 6.00491 3.86508 6.00445 3.99647C6.00399 4.12787 6.02941 4.25807 6.07926 4.37964C6.12911 4.50121 6.20242 4.61177 6.29501 4.70501C6.38759 4.79825 6.49763 4.87234 6.61884 4.92305C6.74006 4.97376 6.87007 5.0001 7.00147 5.00056C7.26683 5.0015 7.5217 4.89699 7.71 4.71001L9 3.42001V9H3.41001L4.71001 7.71C4.89831 7.5217 5.0041 7.26631 5.0041 7C5.0041 6.7337 4.89831 6.47831 4.71001 6.29001C4.52171 6.1017 4.26631 5.99591 4.00001 5.99591C3.73371 5.99591 3.47831 6.1017 3.29001 6.29001L0.290016 9.29C0.197335 9.38344 0.12401 9.49426 0.0742453 9.61609C0.0244808 9.73793 -0.000744178 9.86839 1.67143e-05 10C-0.000744178 10.1316 0.0244808 10.2621 0.0742453 10.3839C0.12401 10.5057 0.197335 10.6166 0.290016 10.71L3.29001 13.71C3.38345 13.8027 3.49427 13.876 3.6161 13.9258C3.73794 13.9755 3.8684 14.0008 4.00001 14C4.13162 14.0008 4.26208 13.9755 4.38392 13.9258C4.50575 13.876 4.61657 13.8027 4.71001 13.71C4.80374 13.617 4.87813 13.5064 4.9289 13.3846C4.97967 13.2627 5.00581 13.132 5.00581 13C5.00581 12.868 4.97967 12.7373 4.9289 12.6154C4.87813 12.4936 4.80374 12.383 4.71001 12.29L3.42001 11H9V16.59L7.71 15.29C7.61677 15.1968 7.50608 15.1228 7.38425 15.0723C7.26243 15.0219 7.13186 14.9959 7 14.9959C6.86815 14.9959 6.73758 15.0219 6.61576 15.0723C6.49393 15.1228 6.38324 15.1968 6.29001 15.29C6.19677 15.3832 6.12281 15.4939 6.07235 15.6157C6.02189 15.7376 5.99591 15.8681 5.99591 16C5.99591 16.1318 6.02189 16.2624 6.07235 16.3842C6.12281 16.5061 6.19677 16.6167 6.29001 16.71L9.29 19.71C9.38344 19.8027 9.49426 19.876 9.61609 19.9258C9.73793 19.9755 9.86839 20.0007 10 20C10.2623 19.9989 10.5137 19.8947 10.7 19.71L13.7 16.71C13.8883 16.5217 13.9941 16.2663 13.9941 16C13.9941 15.7337 13.8883 15.4783 13.7 15.29C13.5117 15.1017 13.2563 14.9959 12.99 14.9959C12.7237 14.9959 12.4683 15.1017 12.28 15.29L11 16.58V11H16.59L15.29 12.29C15.1963 12.383 15.1219 12.4936 15.0711 12.6154C15.0203 12.7373 14.9942 12.868 14.9942 13C14.9942 13.132 15.0203 13.2627 15.0711 13.3846C15.1219 13.5064 15.1963 13.617 15.29 13.71C15.3834 13.8027 15.4942 13.876 15.6161 13.9258C15.7379 13.9755 15.8684 14.0008 16 14C16.1316 14.0008 16.2621 13.9755 16.3839 13.9258C16.5057 13.876 16.6165 13.8027 16.71 13.71L19.71 10.71C19.8027 10.6166 19.876 10.5057 19.9258 10.3839C19.9755 10.2621 20.0007 10.1316 20 10C19.9963 9.74113 19.8923 9.49379 19.71 9.31Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.MOUSE_CLICK:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M6.672 1.911a1 1 0 10-1.932.518l.259.966a1 1 0 001.932-.518l-.26-.966zM2.429 4.74a1 1 0 10-.517 1.932l.966.259a1 1 0 00.517-1.932l-.966-.26zm8.814-.569a1 1 0 00-1.415-1.414l-.707.707a1 1 0 101.415 1.415l.707-.708zm-7.071 7.072l.707-.707A1 1 0 003.465 9.12l-.708.707a1 1 0 001.415 1.415zm3.2-5.171a1 1 0 00-1.3 1.3l4 10a1 1 0 001.823.075l1.38-2.759 3.018 3.02a1 1 0 001.414-1.415l-3.019-3.02 2.76-1.379a1 1 0 00-.076-1.822l-10-4z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.PLAY:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.PAPER_CLIP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          viewBox="0 0 18 18"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M8 4a3 3 0 00-3 3v4a5 5 0 0010 0V7a1 1 0 112 0v4a7 7 0 11-14 0V7a5 5 0 0110 0v4a3 3 0 11-6 0V7a1 1 0 012 0v4a1 1 0 102 0V7a3 3 0 00-3-3z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.PENCIL:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
        </SvgIcon>
      );
    case iconTypes.PIN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M12.1965 1.1418e-06C12.2906 -0.000166868 12.3837 0.018208 12.4707 0.0540754C12.5577 0.0899428 12.6367 0.142599 12.7033 0.209034L19.7904 7.29612C19.9246 7.43036 20 7.61242 20 7.80224C20 7.99206 19.9246 8.17411 19.7904 8.30836C19.1032 8.99559 18.2556 9.15022 17.6385 9.15022C17.3851 9.15022 17.1589 9.12444 16.9799 9.09438L12.4929 13.5814C12.611 14.0574 12.6876 14.5426 12.7219 15.0318C12.7878 16.0369 12.6761 17.4471 11.6911 18.4322C11.5568 18.5664 11.3748 18.6417 11.185 18.6417C10.9951 18.6417 10.8131 18.5664 10.6788 18.4322L6.62847 14.3832L2.07269 18.939C1.7935 19.2182 0.327407 20.2304 0.0482183 19.9512C-0.23097 19.672 0.781266 18.2045 1.06045 17.9267L5.61623 13.371L1.56729 9.32059C1.43308 9.18635 1.35769 9.0043 1.35769 8.81447C1.35769 8.62465 1.43308 8.4426 1.56729 8.30836C2.55232 7.32332 3.96258 7.21022 4.96766 7.27751C5.45682 7.31178 5.94209 7.38843 6.418 7.50659L10.9051 3.02096C10.8676 2.80293 10.8485 2.58215 10.8478 2.36093C10.8478 1.74529 11.0024 0.897699 11.6911 0.209034C11.8252 0.0752116 12.007 4.14007e-05 12.1965 1.1418e-06V1.1418e-06ZM12.3712 3.02382V3.02096V3.02382ZM12.3712 3.02096V3.02382C12.4125 3.14977 12.4181 3.28473 12.3872 3.41365C12.3564 3.54258 12.2904 3.66041 12.1965 3.75401L7.1353 8.81376C7.04126 8.9074 6.92305 8.97305 6.79385 9.00339C6.66466 9.03373 6.52958 9.02756 6.40369 8.98557H6.40082L6.38078 8.97984C6.24457 8.93904 6.10705 8.90275 5.96844 8.87103C5.60827 8.78701 5.24205 8.73148 4.87316 8.70495C4.26897 8.66486 3.67623 8.7164 3.19088 8.91971L11.0797 16.8071C11.2816 16.3203 11.3331 15.729 11.2931 15.1248C11.2566 14.6133 11.1644 14.1073 11.0182 13.6158L11.0124 13.5972V13.5958C10.9702 13.4697 10.9638 13.3343 10.9942 13.2048C11.0245 13.0753 11.0903 12.9569 11.1842 12.8627L16.2469 7.80152C16.3444 7.70344 16.4682 7.63569 16.6033 7.60647C16.7385 7.57725 16.8792 7.58781 17.0085 7.63687L17.146 7.66837C17.2706 7.69271 17.4438 7.71705 17.6385 7.71705C17.8017 7.71705 17.9678 7.7013 18.1296 7.65978L12.3382 1.86985C12.2967 2.03163 12.281 2.19915 12.281 2.36093C12.2817 2.5834 12.3115 2.80482 12.3697 3.01953L12.3712 3.02096Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.PHOTO:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.PRINTER:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.QR_CODE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M3 4a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1V4zm2 2V5h1v1H5zM3 13a1 1 0 011-1h3a1 1 0 011 1v3a1 1 0 01-1 1H4a1 1 0 01-1-1v-3zm2 2v-1h1v1H5zM13 3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1V4a1 1 0 00-1-1h-3zm1 2v1h1V5h-1z"
            clipRule="evenodd"
          />
          <path d="M11 4a1 1 0 10-2 0v1a1 1 0 002 0V4zM10 7a1 1 0 011 1v1h2a1 1 0 110 2h-3a1 1 0 01-1-1V8a1 1 0 011-1zM16 9a1 1 0 100 2 1 1 0 000-2zM9 13a1 1 0 011-1h1a1 1 0 110 2v2a1 1 0 11-2 0v-3zM7 11a1 1 0 100-2H4a1 1 0 100 2h3zM17 13a1 1 0 01-1 1h-2a1 1 0 110-2h2a1 1 0 011 1zM16 17a1 1 0 100-2h-3a1 1 0 100 2h3z" />
        </SvgIcon>
      );
    case iconTypes.QR_VALID:
      return (
        <Svg
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.52139 1.35821V0.957216H8.33122V5.12283V5.71791H8.3579C8.34024 5.52191 8.33122 5.32342 8.33122 5.12283C8.33122 3.7215 8.77155 2.42303 9.52139 1.35821Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.04498 8.09826H8.33122V9.28843H7.14104V10.4786H5.95087V9.28843H3.57052V10.4786H2.38035V9.28843H0V11.6688H3.57052V10.4786H5.95087V11.6688H8.33122V14.0491H10.7116V15.2393H8.33122V16.4295H9.52139V17.6197H8.33122V20H9.52139V17.6197H10.7116V20H13.0919V17.6197H14.2821V20H15.4723V17.6197H14.2821V16.4295H16.6624V20H19.0428V17.6197H17.8526V16.4295H16.6624V15.2393H14.2821V16.4295H13.0919V15.2393H11.9017V14.0491H15.4723V11.6688H13.0919V11.4224C11.7955 11.0557 10.6625 10.2996 9.82746 9.28843H9.52139V8.88744C9.34486 8.63676 9.18549 8.37313 9.04498 8.09826ZM10.7116 11.6688H8.33122V9.28843H9.52139V10.4786H10.7116V11.6688ZM10.7116 11.6688H13.0919V12.859H11.9017V14.0491H10.7116V11.6688ZM11.9017 15.2393H10.7116V17.6197H13.0919V16.4295H11.9017V15.2393Z"
            fill={color}
          />
          <path
            d="M16.6624 11.4224V11.6688H19.0428V10.1725C18.3536 10.7417 17.546 11.1725 16.6624 11.4224Z"
            fill={color}
          />
          <path d="M4.7607 3.33756H2.38035V5.71791H4.7607V3.33756Z" fill={color} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0.957216H7.14105V8.09826H0V0.957216ZM1.19017 6.90809H5.95087V2.14739H1.19017V6.90809Z"
            fill={color}
          />
          <path d="M2.38037 15.2393H4.76071V17.6197H2.38037V15.2393Z" fill={color} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.14105 20H0V12.859H7.14105V20ZM5.95087 14.0491H1.19017V18.8098H5.95087V14.0491Z"
            fill={color}
          />
          <path d="M16.6624 14.0491V12.859H19.0428V15.2393H17.8526V14.0491H16.6624Z" fill={color} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 5.12283C20 2.29384 17.7069 -0.000793457 14.8772 -0.000793457C12.0475 -0.000793457 9.75436 2.29384 9.75435 5.12283C9.75435 7.95182 12.0475 10.2456 14.8772 10.2456C17.7069 10.2456 20 7.95182 20 5.12283ZM13.5915 5.80922L17.3854 2.01446L18.6008 3.22983L13.5995 8.23119L11.1535 5.78525L12.3609 4.57866L13.5915 5.80922Z"
            fill={color}
          />
        </Svg>
      );
    case iconTypes.QR_NOT_VALID:
      return (
        <Svg
          title={title}
          width={width}
          height={height}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.58084 1.24182V0.83832H8.38323V5.02994V5.62874H8.41008C8.39231 5.43152 8.38323 5.23179 8.38323 5.02994C8.38323 3.61987 8.82631 2.31328 9.58084 1.24182Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.10145 8.02395H8.38323V9.22155H7.18563V10.4192H5.98802V9.22155H3.59281V10.4192H2.39521V9.22155H0V11.6168H3.59281V10.4192H5.98802V11.6168H8.38323V14.012H10.7784V15.2096H8.38323V16.4072H9.58084V17.6048H8.38323V20H9.58084V17.6048H10.7784V20H13.1736V17.6048H14.3713V20H15.5689V17.6048H14.3713V16.4072H16.7665V20H19.1617V17.6048H17.9641V16.4072H16.7665V15.2096H14.3713V16.4072H13.1736V15.2096H11.976V14.012H15.5689V11.6168H13.1736V11.3688C11.8691 10.9999 10.7291 10.239 9.88881 9.22155H9.58084V8.81806C9.4032 8.56581 9.24284 8.30054 9.10145 8.02395ZM10.7784 11.6168H8.38323V9.22155H9.58084V10.4192H10.7784V11.6168ZM10.7784 11.6168H13.1736V12.8144H11.976V14.012H10.7784V11.6168ZM11.976 15.2096H10.7784V17.6048H13.1736V16.4072H11.976V15.2096Z"
            fill={color}
          />
          <path
            d="M16.7665 11.3688V11.6168H19.1617V10.1112C18.4682 10.6839 17.6556 11.1174 16.7665 11.3688Z"
            fill={color}
          />
          <path d="M4.79042 3.23353H2.39521V5.62874H4.79042V3.23353Z" fill={color} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0.83832H7.18563V8.02395H0V0.83832ZM1.1976 6.82634H5.98802V2.03592H1.1976V6.82634Z"
            fill={color}
          />
          <path d="M2.39523 15.2096H4.79044V17.6048H2.39523V15.2096Z" fill={color} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.18563 20H0V12.8144H7.18563V20ZM5.98802 14.012H1.1976V18.8024H5.98802V14.012Z"
            fill={color}
          />
          <path d="M16.7665 14.012V12.8144H19.1617V15.2096H17.9641V14.012H16.7665Z" fill={color} />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20 5.02994C20 7.8079 17.748 10.0599 14.9701 10.0599C12.1921 10.0599 9.94012 7.8079 9.94012 5.02994C9.94012 2.25198 12.1921 0 14.9701 0C17.748 0 20 2.25198 20 5.02994ZM16.8802 7.86227L14.9701 5.95209L13.0599 7.86227C12.9391 7.98303 12.7854 8.04341 12.5988 8.04341C12.4122 8.04341 12.2585 7.98303 12.1377 7.86227C12.017 7.74151 11.9566 7.58782 11.9566 7.4012C11.9566 7.21457 12.017 7.06087 12.1377 6.94012L14.0479 5.02994L12.1377 3.11976C12.017 2.999 11.9566 2.84531 11.9566 2.65868C11.9566 2.47205 12.017 2.31836 12.1377 2.1976C12.2585 2.07685 12.4122 2.01647 12.5988 2.01647C12.7854 2.01647 12.9391 2.07685 13.0599 2.1976L14.9701 4.10778L16.8802 2.1976C17.001 2.07685 17.1547 2.01647 17.3413 2.01647C17.5279 2.01647 17.6816 2.07685 17.8024 2.1976C17.9231 2.31836 17.9835 2.47205 17.9835 2.65868C17.9835 2.84531 17.9231 2.999 17.8024 3.11976L15.8922 5.02994L17.8024 6.94012C17.9231 7.06087 17.9835 7.21457 17.9835 7.4012C17.9835 7.58782 17.9231 7.74151 17.8024 7.86227C17.6816 7.98303 17.5279 8.04341 17.3413 8.04341C17.1547 8.04341 17.001 7.98303 16.8802 7.86227Z"
            fill={color}
          />
        </Svg>
      );
    case iconTypes.RESET_ZOOM:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 16"
          fill="none"
        >
          <g clipPath="url(#clip0_1446_2)">
            <path
              d="M8.75 16.25C12.8921 16.25 16.25 12.8921 16.25 8.75C16.25 4.60786 12.8921 1.25 8.75 1.25C4.60786 1.25 1.25 4.60786 1.25 8.75C1.25 12.8921 4.60786 16.25 8.75 16.25Z"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.375 14.375L18.75 18.75M5.625 7.5V5.625H7.5M10 5.625H11.875V7.5M5.625 10V11.875H7.5M11.875 10V11.875H10"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_1446_2">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.REFRESH:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 16"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.RULE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 16"
          fill="none"
        >
          <g clipPath="url(#clip0)">
            <path
              d="M19.8657 5.22495L17.3782 0.990571C17.1032 0.521821 16.4938 0.362445 16.0188 0.631196L13.8626 1.85307L15.7282 5.0312C15.7969 5.14995 15.7563 5.29682 15.6376 5.36557L15.2063 5.60932C15.0876 5.67807 14.9344 5.63745 14.8657 5.5187L13.0001 2.3437L11.2751 3.32182L12.1469 4.80307C12.2157 4.92182 12.1751 5.0687 12.0563 5.13745L11.6251 5.3812C11.5063 5.44995 11.3532 5.40932 11.2844 5.29057L10.4126 3.81245L8.68756 4.79057L10.5563 7.9687C10.6251 8.08432 10.5844 8.23432 10.4657 8.30307L10.0344 8.54682C9.91569 8.61557 9.76256 8.57495 9.69381 8.4562L7.82819 5.27807L6.10319 6.2562L6.97506 7.73745C7.04381 7.8562 7.00319 8.00307 6.88444 8.07182L6.45319 8.31557C6.33444 8.38432 6.18131 8.3437 6.11256 8.22495L5.24068 6.74057L3.51568 7.7187L5.38131 10.8968C5.45006 11.0124 5.40944 11.1624 5.29069 11.2312L4.85944 11.4749C4.74069 11.5437 4.58756 11.5031 4.51881 11.3843L2.65318 8.21557L0.496935 9.43745C0.0219349 9.70932 -0.14369 10.3062 0.13131 10.7749L2.61881 15.0124C2.89381 15.4812 3.50318 15.6406 3.97818 15.3718L19.5032 6.56245C19.9782 6.2937 20.1407 5.6937 19.8657 5.22495Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="20" height="16" fill="white" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.SCISSORS:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M5.5 2a3.5 3.5 0 101.665 6.58L8.585 10l-1.42 1.42a3.5 3.5 0 101.414 1.414l8.128-8.127a1 1 0 00-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 005.5 2zM4 5.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm0 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0z"
            clipRule="evenodd"
          />
          <path d="M12.828 11.414a1 1 0 00-1.414 1.414l3.879 3.88a1 1 0 001.414-1.415l-3.879-3.879z" />
        </SvgIcon>
      );
    case iconTypes.SEARCH:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.SHARING_UPDATE_ON:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 22"
          fill={color}
        >
          <path
            d="M15.6352 2.71613C11.5586 0.19097 6.14971 0.952367 2.97305 4.73816C2.07764 5.8038 1.42056 7.04867 1.04594 8.3892C0.671311 9.72973 0.587804 11.1349 0.801024 12.5104L4.43116 12.4313C4.01255 10.5997 4.40297 8.58798 5.70783 7.03291C6.6134 5.95774 7.85667 5.22126 9.23471 4.94368C10.6128 4.6661 12.0442 4.86381 13.2954 5.50454L11.2076 7.99265L18.6471 7.83864L17.507 0.485413L15.6352 2.71613Z"
            fill={color}
          />
          <path
            d="M11.4846 20.5556C10.6035 19.6844 10.0446 18.4881 10.0026 17.1613C8.86787 17.2464 7.72618 17.0186 6.70463 16.4955L8.79241 14.0073C7.55281 14.0363 6.31277 14.0603 5.07274 14.0843C3.83265 14.1084 2.59256 14.1324 1.3529 14.1614L2.49309 21.5146L4.36489 19.2839C6.53831 20.6301 9.09299 21.0392 11.4846 20.5556Z"
            fill={color}
          />
          <path
            d="M18.8858 13.8533C18.0962 12.8794 16.9478 12.2082 15.6419 12.0408C15.7807 11.2182 15.7534 10.376 15.5689 9.56874L19.199 9.48964C19.4141 10.8651 19.3315 12.2707 18.9568 13.6115C18.9341 13.6925 18.9105 13.773 18.8858 13.8533Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 21C15.5253 21 16.0454 20.8965 16.5307 20.6955C17.016 20.4945 17.457 20.1999 17.8284 19.8284C18.1999 19.457 18.4945 19.016 18.6955 18.5307C18.8965 18.0454 19 17.5253 19 17C19 16.4747 18.8965 15.9546 18.6955 15.4693C18.4945 14.984 18.1999 14.543 17.8284 14.1716C17.457 13.8001 17.016 13.5055 16.5307 13.3045C16.0454 13.1035 15.5253 13 15 13C13.9391 13 12.9217 13.4214 12.1716 14.1716C11.4214 14.9217 11 15.9391 11 17C11 18.0609 11.4214 19.0783 12.1716 19.8284C12.9217 20.5786 13.9391 21 15 21ZM17.1191 15.9511L16.4364 15.3822L14.5253 17.6751L13.5364 16.6858L12.908 17.3142L14.5853 18.9916L17.1191 15.9511Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.SHARING_UPDATE_OFF:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 22"
          fill={color}
        >
          <path
            d="M1.85275 6.38829C1.51164 7.0216 1.24064 7.69248 1.04593 8.3892C0.671308 9.72973 0.587801 11.1349 0.801021 12.5104L4.43116 12.4313C4.18186 11.3405 4.21949 10.1859 4.56631 9.10185L1.85275 6.38829Z"
            fill={color}
          />
          <path
            d="M12.0935 16.629C11.6709 16.8197 11.2256 16.9636 10.7653 17.0563C9.38728 17.3339 7.95584 17.1362 6.70463 16.4955L8.7924 14.0073C7.55277 14.0363 6.31271 14.0603 5.07265 14.0843C3.83259 14.1084 2.59252 14.1324 1.35289 14.1614L2.49308 21.5146L4.36488 19.2839C7.57226 21.2706 11.6099 21.2163 14.7287 19.2642L12.0935 16.629Z"
            fill={color}
          />
          <path
            d="M18.1487 15.6132L15.4337 12.8982C15.7805 11.8141 15.8182 10.6595 15.5689 9.56874L19.199 9.48964C19.4141 10.8651 19.3315 12.2707 18.9568 13.6115C18.7619 14.3087 18.4905 14.9798 18.1487 15.6132Z"
            fill={color}
          />
          <path
            d="M7.90649 5.37096L5.27012 2.73458C8.39155 0.777143 12.4261 0.728366 15.6351 2.71613L17.5069 0.485413L18.6471 7.83864L11.2076 7.99265L13.2954 5.50454C12.0442 4.86381 10.6128 4.6661 9.23471 4.94369C8.77441 5.0364 8.32915 5.18032 7.90649 5.37096Z"
            fill={color}
          />
          <path d="M2.82843 1L19.799 17.9706L16.9706 20.799L0 3.82843L2.82843 1Z" fill={color} />
        </SvgIcon>
      );
    case iconTypes.SETTINGS:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z" />
        </SvgIcon>
      );
    case iconTypes.SHARE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path d="M15 8a3 3 0 10-2.977-2.63l-4.94 2.47a3 3 0 100 4.319l4.94 2.47a3 3 0 10.895-1.789l-4.94-2.47a3.027 3.027 0 000-.74l4.94-2.47C13.456 7.68 14.19 8 15 8z" />
        </SvgIcon>
      );
    case iconTypes.SORT_NAME_UP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M8.05263 1.78947H17V3.57895H8.05263V1.78947ZM8.05263 14.3158V12.5263H17V14.3158H8.05263ZM8.05263 7.15789H17V8.94737H8.05263V7.15789ZM5.36842 8.94737V10.7368L2.38895 14.3158H5.36842V16.1053H0V14.3158L2.97947 10.7368H0V8.94737H5.36842ZM3.57895 0H1.78947C0.805263 0 0 0.805263 0 1.78947V7.15789H1.78947V5.36842H3.57895V7.15789H5.36842V1.78947C5.36842 1.31488 5.17989 0.859716 4.8443 0.524125C4.5087 0.188533 4.05355 0 3.57895 0ZM3.57895 3.57895H1.78947V1.78947H3.57895V3.57895Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.SORT_NAME_DOWN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3.57895 8.94737H1.78947C0.805263 8.94737 0 9.75263 0 10.7368V16.1053H1.78947V14.3158H3.57895V16.1053H5.36842V10.7368C5.36842 10.2622 5.17989 9.80708 4.8443 9.47149C4.5087 9.1359 4.05355 8.94737 3.57895 8.94737ZM3.57895 12.5263H1.78947V10.7368H3.57895V12.5263ZM5.36842 0V1.78947L2.38895 5.36842H5.36842V7.15789H0V5.36842L2.97947 1.78947H0V0H5.36842ZM8.05263 1.78947H17V3.57895H8.05263V1.78947ZM8.05263 14.3158V12.5263H17V14.3158H8.05263ZM8.05263 7.15789H17V8.94737H8.05263V7.15789Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.SORT_NUMBER_UP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3.57895 16.1053H0V14.3158H3.57895V13.4211H1.78947C1.31488 13.4211 0.859716 13.2325 0.524125 12.8969C0.188533 12.5613 0 12.1062 0 11.6316V10.7368C0 9.75263 0.805263 8.94737 1.78947 8.94737H3.57895C4.05355 8.94737 4.5087 9.1359 4.8443 9.47149C5.17989 9.80708 5.36842 10.2622 5.36842 10.7368V14.3158C5.36842 15.3089 4.57211 16.1053 3.57895 16.1053ZM3.57895 10.7368H1.78947V11.6316H3.57895V10.7368ZM1.78947 0H3.57895C4.05355 0 4.5087 0.188533 4.8443 0.524125C5.17989 0.859716 5.36842 1.31488 5.36842 1.78947V5.36842C5.36842 6.36158 4.57211 7.15789 3.57895 7.15789H1.78947C1.31488 7.15789 0.859716 6.96936 0.524125 6.63377C0.188533 6.29818 0 5.84302 0 5.36842V1.78947C0 0.805263 0.805263 0 1.78947 0ZM1.78947 5.36842H3.57895V1.78947H1.78947V5.36842ZM8.05263 1.78947H17V3.57895H8.05263V1.78947ZM8.05263 14.3158V12.5263H17V14.3158H8.05263ZM8.05263 7.15789H17V8.94737H8.05263V7.15789Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.SORT_NUMBER_DOWN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M3.57895 7.15789H0V5.36842H3.57895V4.47368H1.78947C1.31488 4.47368 0.859716 4.28515 0.524125 3.94956C0.188533 3.61397 0 3.15881 0 2.68421V1.78947C0 0.805263 0.805263 0 1.78947 0H3.57895C4.05355 0 4.5087 0.188533 4.8443 0.524125C5.17989 0.859716 5.36842 1.31488 5.36842 1.78947V5.36842C5.36842 6.36158 4.57211 7.15789 3.57895 7.15789ZM3.57895 1.78947H1.78947V2.68421H3.57895V1.78947ZM1.78947 8.94737H3.57895C4.05355 8.94737 4.5087 9.1359 4.8443 9.47149C5.17989 9.80708 5.36842 10.2622 5.36842 10.7368V14.3158C5.36842 15.3089 4.57211 16.1053 3.57895 16.1053H1.78947C1.31488 16.1053 0.859716 15.9167 0.524125 15.5811C0.188533 15.2455 0 14.7904 0 14.3158V10.7368C0 9.75263 0.805263 8.94737 1.78947 8.94737ZM1.78947 14.3158H3.57895V10.7368H1.78947V14.3158ZM8.05263 1.78947H17V3.57895H8.05263V1.78947ZM8.05263 14.3158V12.5263H17V14.3158H8.05263ZM8.05263 7.15789H17V8.94737H8.05263V7.15789Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.STATUS_DEADLINE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <rect width="7.214" height="2.439" x="4.878" fill={color} rx="1.22" />
          <rect
            width="5.244"
            height="2.439"
            x="15.446"
            y="1.951"
            fill={color}
            rx="1.22"
            transform="rotate(52.552 15.446 1.951)"
          />
          <circle
            cx="8.293"
            cy="11.707"
            r="7.125"
            stroke={color}
            strokeWidth="2.335"
            fill={innerColor ? innerColor : 'none'}
          />
          <path
            stroke={color}
            strokeWidth=".934"
            d="M8.64 7.319v1.024c0 .084-.113.111-.15.036-.042-.084-.169-.04-.15.05l.295 1.488a.282.282 0 0 1 .005.055v1.356a.72.72 0 0 1-.209.507l-.122.123a.297.297 0 0 0 .209.507c.078 0 .154.032.209.087l.245.247a.297.297 0 0 1 .087.21c0 .164.133.297.297.297h.957m0 0-.332-.333a.3.3 0 0 1-.086-.21.297.297 0 0 0-.296-.298.295.295 0 0 1-.209-.087l-.123-.123a.716.716 0 0 1-.208-.505v-.125m1.254 1.68a.425.425 0 0 1-.682-.11l-.154-.31-.418-1.26m0 0V8.263m.418 1.26V8.269a1.03 1.03 0 0 0-.3-.727.654.654 0 0 0-.275-.177c-.2-.058-.554-.107-.847.144-.21.18-.25.478-.25.755v3.781c0 .27.106.527.296.718l.121.123.418.42.419.42.123.124c.189.19.445.296.713.296h.12a.716.716 0 0 0 .716-.716v-.124c0-.27-.107-.527-.296-.718l-.122-.123-.418-.42-.122-.122a1.02 1.02 0 0 1-.296-.718V9.524Z"
          />
        </SvgIcon>
      );
    case iconTypes.FILE_OCCURRENCES_FINISHED:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2.5"
            d="m2 13.043 2.677 2.87c1.476 1.584 2.215 2.374 3.041 2.624.727.218 1.5.16 2.192-.167.788-.373 1.42-1.268 2.687-3.06L22 2"
          />
        </SvgIcon>
      );
    case iconTypes.FILE_OCCURRENCES_OVERDUE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            stroke={color}
            strokeWidth="1.5"
            d="M3.98 7.986C6.608 3.328 7.92 1 10 1c2.079 0 3.393 2.328 6.02 6.986l.327.58c2.182 3.87 3.274 5.804 2.287 7.219-.986 1.415-3.427 1.415-8.306 1.415h-.656c-4.88 0-7.32 0-8.306-1.415-.987-1.415.105-3.35 2.287-7.22l.328-.58Z"
          />
          <path stroke={color} strokeLinecap="round" strokeWidth="1.5" d="M10 5.5V10" />
          <path fill={color} d="M10 13.6a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z" />
        </SvgIcon>
      );
    case iconTypes.FILE_OCCURRENCES_ON_TIME:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            fill={color}
            d="M14.039 18.38c-.113-4.706-2.431-5.88-3.767-6.557l-.099-.05-.011-.006c-.22-.113-.413-.212-.57-.313-.34-.218-.502-.473-.502-.783 0-.31.163-.565.502-.782a6.846 6.846 0 0 1 .581-.318c1.326-.676 3.525-1.803 3.61-6.725a1.129 1.129 0 0 0-.241-2.23H1.4a1.13 1.13 0 0 0-.268 2.224c.082 4.93 2.284 6.056 3.61 6.733.226.114.42.214.582.316.336.217.5.474.5.784 0 .31-.164.565-.5.782a6.85 6.85 0 0 1-.547.3l-.034.018a66.98 66.98 0 0 1-.109.055C3.3 12.507.99 13.678.88 18.381c-.495.12-.608.573-.608 1.105 0 .623.507 1.13 1.13 1.13h12.14c.621 0 1.129-.507 1.129-1.13 0-.543-.124-.996-.631-1.105Zm-8.971-5.824a4.95 4.95 0 0 0 .52-.336c.09-.064.172-.122.237-.164.686-.441.716-.997.716-1.383 0-.388-.144-.944-.831-1.385-.185-.12-.398-.228-.625-.344l-.017-.008C3.742 8.26 2.638 7.34 2.546 2.915h9.875c-.092 4.424-1.248 5.345-2.573 6.02a7.027 7.027 0 0 0-.642.352c-.687.442-.831.998-.831 1.386 0 .388.028.942.715 1.383.112.072.273.14.433.208.114.048.228.097.325.146 1.317.671 2.652 1.623 2.763 5.98H2.277c.113-4.359 1.475-5.163 2.79-5.834Z"
          />
          <path
            stroke={color}
            d="M14.039 18.38c-.113-4.706-2.431-5.88-3.767-6.557l-.099-.05-.011-.006c-.22-.113-.413-.212-.57-.313-.34-.218-.502-.473-.502-.783 0-.31.163-.565.502-.782a6.846 6.846 0 0 1 .581-.318c1.326-.676 3.525-1.803 3.61-6.725a1.129 1.129 0 0 0-.241-2.23H1.4a1.13 1.13 0 0 0-.268 2.224c.082 4.93 2.284 6.056 3.61 6.733.226.114.42.214.582.316.336.217.5.474.5.784 0 .31-.164.565-.5.782a6.85 6.85 0 0 1-.547.3l-.034.018a66.98 66.98 0 0 1-.109.055C3.3 12.507.99 13.678.88 18.381c-.495.12-.608.573-.608 1.105 0 .623.507 1.13 1.13 1.13h12.14c.621 0 1.129-.507 1.129-1.13 0-.543-.124-.996-.631-1.105Zm-8.971-5.824a4.95 4.95 0 0 0 .52-.336c.09-.064.172-.122.237-.164.686-.441.716-.997.716-1.383 0-.388-.144-.944-.831-1.385-.185-.12-.398-.228-.625-.344l-.017-.008C3.742 8.26 2.638 7.34 2.546 2.915h9.875c-.092 4.424-1.248 5.345-2.573 6.02a7.027 7.027 0 0 0-.642.352c-.687.442-.831.998-.831 1.386 0 .388.028.942.715 1.383.112.072.273.14.433.208.114.048.228.097.325.146 1.317.671 2.652 1.623 2.763 5.98H2.277c.113-4.359 1.475-5.163 2.79-5.834Z"
          />
          <path
            fill={color}
            d="M12.048 15.695H8.597l-.144-1.443-.7-3.58h.004c0-.766.396-1.442 1.116-1.904.21-.137.438-.253.677-.375.395-.202 1.21-1.055 1.63-1.414H3.907c.415.357 1.054 1.207 1.441 1.404.258.132.484.248.695.384.718.461 1.114 1.137 1.114 1.904l-.522 3.581-.123 1.443H2.869c-.186.567-.32 1.258-.376 2.116h9.93c-.057-.858-.19-1.55-.375-2.116Z"
          />
        </SvgIcon>
      );
    case iconTypes.TABLE:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M5 4a3 3 0 00-3 3v6a3 3 0 003 3h10a3 3 0 003-3V7a3 3 0 00-3-3H5zm-1 9v-1h5v2H5a1 1 0 01-1-1zm7 1h4a1 1 0 001-1v-1h-5v2zm0-4h5V8h-5v2zM9 8H4v2h5V8z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.TAG:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.THUMB_UP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path d="M2 10.5a1.5 1.5 0 113 0v6a1.5 1.5 0 01-3 0v-6zM6 10.333v5.43a2 2 0 001.106 1.79l.05.025A4 4 0 008.943 18h5.416a2 2 0 001.962-1.608l1.2-6A2 2 0 0015.56 8H12V4a2 2 0 00-2-2 1 1 0 00-1 1v.667a4 4 0 01-.8 2.4L6.8 7.933a4 4 0 00-.8 2.4z" />
        </SvgIcon>
      );
    case iconTypes.THUMB_DOWN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path d="M18 9.5a1.5 1.5 0 11-3 0v-6a1.5 1.5 0 013 0v6zM14 9.667v-5.43a2 2 0 00-1.105-1.79l-.05-.025A4 4 0 0011.055 2H5.64a2 2 0 00-1.962 1.608l-1.2 6A2 2 0 004.44 12H8v4a2 2 0 002 2 1 1 0 001-1v-.667a4 4 0 01.8-2.4l1.4-1.866a4 4 0 00.8-2.4z" />
        </SvgIcon>
      );
    case iconTypes.TINT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_1413_2)">
            <path
              d="M2.93164 12.9192C2.95397 11.5035 3.34826 10.2298 4.05756 9.12854C4.78842 8.03392 5.60029 6.96882 6.27814 5.95092C7.35417 4.29152 8.26629 2.57262 8.82399 0.809203C9.01784 0.256053 9.45794 -0.0567639 9.99996 0.00855277C10.604 -0.0285306 11.0223 0.293219 11.1759 0.809219C11.7632 2.71867 12.6996 4.38772 13.7343 5.95094C14.4409 7.10294 15.248 7.99207 15.9423 9.12855C16.6957 10.3258 17.0615 11.6211 17.0683 12.9192C17.0253 14.8557 16.2633 16.656 15.0103 17.9358C13.6128 19.2786 11.7742 19.9872 9.99996 20C8.06436 19.9588 6.26907 19.1906 4.99584 17.9358C3.65582 16.5338 2.94441 14.6951 2.93164 12.9192ZM6.03422 14.483C6.08059 15.5025 6.89051 16.2472 7.79816 16.2595C8.82677 16.2139 9.55021 15.3903 9.56211 14.483C9.56211 14.1243 9.47036 13.8116 9.28687 13.5447C9.08519 13.2823 8.88637 13.0106 8.72394 12.7503C8.46657 12.33 8.21492 11.9121 8.08591 11.468C8.05256 11.3012 7.95664 11.2303 7.79816 11.2553C7.64802 11.222 7.54794 11.2929 7.49791 11.468C7.36301 11.9437 7.12727 12.363 6.87864 12.7503C6.70376 13.0421 6.49416 13.2692 6.30946 13.5447C6.11762 13.8199 6.02587 14.1327 6.03422 14.483Z"
              fill={color}
            />
          </g>
          <defs>
            <clipPath id="clip0_1413_2">
              <rect width={width} height={height} fill="white" />
            </clipPath>
          </defs>
        </SvgIcon>
      );
    case iconTypes.TRASH:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.USER_ADD:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
        </SvgIcon>
      );
    case iconTypes.USER:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.USER_REMOVED:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path d="M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z" />
        </SvgIcon>
      );
    case iconTypes.USER_GROUP:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill={color}
        >
          <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
        </SvgIcon>
      );
    case iconTypes.WRENCH:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M13.5 2C12.8361 1.99986 12.1803 2.14664 11.5798 2.4298C10.9793 2.71296 10.4489 3.1255 10.0266 3.63782C9.60433 4.15014 9.30064 4.74956 9.13733 5.39309C8.97402 6.03662 8.95512 6.70831 9.08201 7.36L2.65701 14.018C2.22033 14.4654 1.97927 15.068 1.98687 15.6931C1.99446 16.3183 2.25009 16.9148 2.69751 17.3515C3.14493 17.7882 3.74749 18.0292 4.37265 18.0216C4.9978 18.014 5.59433 17.7584 6.03101 17.311L12.395 10.863C13.1427 11.0525 13.9266 11.0465 14.6714 10.8458C15.4162 10.645 16.0968 10.2562 16.6481 9.71661C17.1993 9.17703 17.6026 8.50482 17.8192 7.7645C18.0358 7.02418 18.0585 6.24061 17.885 5.489C17.8648 5.40219 17.8218 5.32235 17.7605 5.25774C17.6991 5.19313 17.6215 5.1461 17.5359 5.12153C17.4502 5.09695 17.3595 5.09572 17.2732 5.11795C17.1869 5.14019 17.1081 5.18509 17.045 5.248L14.5 7.793L12.207 5.5L14.752 2.955C14.8149 2.89188 14.8598 2.81309 14.8821 2.72679C14.9043 2.64048 14.9031 2.54981 14.8785 2.46414C14.8539 2.37848 14.8069 2.30094 14.7423 2.23955C14.6777 2.17817 14.5978 2.13517 14.511 2.115C14.1794 2.03868 13.8403 2.0001 13.5 2Z"
            fill={color}
          />
        </SvgIcon>
      );
    case iconTypes.ZOOM_IN:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path d="M5 8a1 1 0 011-1h1V6a1 1 0 012 0v1h1a1 1 0 110 2H9v1a1 1 0 11-2 0V9H6a1 1 0 01-1-1z" />
          <path
            fillRule="evenodd"
            d="M2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8zm6-4a4 4 0 100 8 4 4 0 000-8z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    case iconTypes.ZOOM_OUT:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill={color}
        >
          <path
            fillRule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            clipRule="evenodd"
          />
          <path
            fillRule="evenodd"
            d="M5 8a1 1 0 011-1h4a1 1 0 110 2H6a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </SvgIcon>
      );
    default:
      return (
        <SvgIcon
          title={title}
          width={width}
          height={height}
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 18 18"
          fill="red"
        >
          <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3a1 1 0 000 1.84L5.25 8.051a.999.999 0 01.356-.257l4-1.714a1 1 0 11.788 1.838L7.667 9.088l1.94.831a1 1 0 00.787 0l7-3a1 1 0 000-1.838l-7-3zM3.31 9.397L5 10.12v4.102a8.969 8.969 0 00-1.05-.174 1 1 0 01-.89-.89 11.115 11.115 0 01.25-3.762zM9.3 16.573A9.026 9.026 0 007 14.935v-3.957l1.818.78a3 3 0 002.364 0l5.508-2.361a11.026 11.026 0 01.25 3.762 1 1 0 01-.89.89 8.968 8.968 0 00-5.35 2.524 1 1 0 01-1.4 0zM6 18a1 1 0 001-1v-2.065a8.935 8.935 0 00-2-.712V17a1 1 0 001 1z" />
        </SvgIcon>
      );
  }
};

const typeNames = (() => {
  const types = [];
  for (const type in iconTypes) {
    types.push(iconTypes[type]);
  }
  return types;
})();

ProjectIcons.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  noFlex: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.oneOf(typeNames),
  width: PropTypes.number,
};
